import React, { Component, Fragment } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import "react-table/react-table.css";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { NavLink } from "react-router-dom";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Card from "components/Card/Card.jsx";
import { connect } from 'react-redux';
import reservationActions from 'actions/reservation.actions';
import { reservationService } from 'services/reservation.services';
import { mainService } from 'services/main.services';
import Notes from "views/Main/Notes.jsx";
import moment from 'moment-timezone';
import Modal from 'react-responsive-modal';
import { Loader } from "components/Loader/Loader.jsx";
import config from 'config';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import InputMask from 'react-input-mask';
import numeral from 'numeral';
import _ from 'lodash';
import CustomPrice from "../../components/Popup/CustomPrice";
import { constructPricesMap, serverErrorMessage } from "../../helpers/utility";
import stopActions from 'actions/stop.actions';
import SeatMap from '../../components/SeatSelection/SeatMap';
import SeatLegend from '../../components/SeatSelection/SeatLegend';
import { getBusLayout, getAllSeatIds, getSeatPrice, getPaidSeatValue } from '../../components/SeatSelection/seatConfig';
import getSessionId from '../../helpers/sessionId';
import { scheduleService } from '../../services/schedule.services';
import '../../components/SeatSelection/SeatSelection.css';

//moment.tz.setDefault('America/New_York');

/*eslint-disable no-script-url*/

function queryStringToJSON(param) {            
  var pairs = param.slice(1).split('&');
  var result = {};
  pairs.forEach(function(pair) {
    pair = pair.split('=');
    result[pair[0]] = decodeURIComponent(pair[1] || '');
  });
  return JSON.parse(JSON.stringify(result));
}


class SearchReservations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      criteria: {},
      editingId: -1,
      rowObject: null,
      noSchedule: false,
      hasMore: true,
      openNotes: false,
      openCancel: false,
      openBook: false,
      openActionDetails: false,
      openSchedule: false,
      departDate: moment(),
      openReschedule: false,
      departCity: '',
      arriveCity: '',
      departStop: '',
      arriveStop: '',
      slot: '',
      paymentMethod: 'card',
      credits: 0,
      points: 0,
      pointsAmount: 0,
      remark: '',
      customAmount: '',
      waiveDifference: false,
      methods: [
        {label: 'Credit Card', value: 'card'},
        {label: 'No Payment', value: 'none'},
        {label: 'Customer Already Paid', value: 'alreadyPaid'},
      ],
      cardHolder: '',
      number: '',
      month: '',
      year: '',
      cvv: '',
      openSuccess: false,
      openSentSuccess: false,
      openUpdateSuccess: false,
      credit: '',
      months: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      years: [],
      notesData: null,
      selectedLeg: null,
      selectedStop: null,
      selectedBus: null,
      actionRecord: null,
      seatsToCancel: '',
      seatsToReschedule: '',
      rescheduleOldSeatNumbers: [],
      submitted: false,
      loading: false,
      body: '',
      text: '',
      subject: '',
      action: '',
      order: '',
      schedules: null,
      selected: [],
      fields: {
        user: true,
        email: true,
        seats: true,
        legPrice: false,
        pointsUsed: false,
        pointsEarned: false,
        creditUsed: false,
        otherLeg: false,
        created_at: false,
        paid: false,
        reservationNumber: true,
        paymentGatewayId: false,
        user_ip: false,
        phone: true,
        action_records: false,
        checked: false,
        made_by: false,
        paymentMethod: false,
        account: false,
        promo: false,
        slot: true,
        date: true,
        stop: true
      },
      bulkActionInfo: '',
      currentSelectedBus: null,
      currentSelectedBusIndex: null,
      showModal: false,
      arriveCities: [],
      selectedRoutePrice: null,
      rescheduleSelectedSeats: [],
      rescheduleTakenSeats: [],
      rescheduleTempTakenSeats: [],
      rescheduleSeatInfoLoading: false,
      reschedulePricingTiers: [],
      showRescheduleSeatSelection: false,
      skipSeatSelection: false,
      reschedulePendingSeats: [],
      reschedulePendingReleaseSeats: [],
      cancelSeatNumbers: [],
      cancelBusLayout: null,
      cancelTakenSeats: [],
      cancelSeatInfoLoading: false,
      // Manage Seats (unified modal for switch / remove / assign)
      openManageSeats: false,
      manageSeatTab: 'switch',
      cancelAddonSeats: [],
      cancelAddonLoading: false,
      switchStep: 1,
      seatsToSwitch: [],
      switchMappings: {},
      switchActiveIndex: 0,
      switchPriceDiff: 0,
      switchLoading: false,
      switchBusLayout: null,
      switchMaxSelectableRow: null,
      switchTakenSeats: [],
      switchTemporaryTakenSeats: [],
      switchSeatInfoLoading: false,
      switchPendingSeats: [],
      switchPendingReleaseSeats: [],
      switchPaymentMethod: 'none',
      switchHoldError: null,
      assignSelectedSeats: [],
      assignMaxSeats: 0,
      assignPendingSeats: [],
      assignPendingReleaseSeats: [],
      applyCredits: false,
      switchCardErrors: {},
      manageSeatSuccess: null,
      cancelUnassignedCount: 0,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleRescheduleSeatSelect = this.handleRescheduleSeatSelect.bind(this);
    this.handleRefreshRescheduleSeats = this.handleRefreshRescheduleSeats.bind(this);
    this._handleBeforeUnload = this._handleBeforeUnload.bind(this);
    this.handleCancelSeatToggle = this.handleCancelSeatToggle.bind(this);
  }

  editRow(res) {
    const fields = {...this.state.fields};
    fields.account = true;
    this.setState({
      editingId: res.id,
      fields: fields,
      rowObject: {
        firstName: res.firstName || '',
        lastName: res.lastName || '',
      }
    });
  }

  saveRow() {
    this.setState({loading: true})
    mainService.updateReservationLeg(this.state.editingId, this.state.rowObject)
    .then(result => {
      this.setState({openUpdateSuccess: true, loading: false, editingId: null});
    })
    .catch(err => {
      this.setState({loading: false});
      console.log(err);
    })
  }

  getActiveReservations(reservations) {
    return _.filter(reservations, {status: 'active'});
  }

  handleChange(e) {
    const { name, value } = e.target;
    if(name === 'departCity'){
      this.setState({ [name]: value });
      let arriveCities = [];
      if(e.target.value === 'new york' || e.target.value === 'brooklyn') {
        (this.props.stops || []).map((item) => {
          if(!(['new york', 'brooklyn'].includes(item.city))) {
            arriveCities.push(item);
          }
          return item;
        });
      }
      else {
        (this.props.stops || []).map((item) => {
          if(item.city === 'new york' || item.city == 'brooklyn') {
            arriveCities.push(item);
          }
          return item;
        });
      }
    this.setState({arriveCities})
  }else{
    this.setState({ [name]: value });
  }
  }

  handleOrder(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  handleDepartDate(date) {
    this.setState({ departDate: date });
  }

  handleDateChangeRaw(e) {
    e.preventDefault();
    return;
  }

  sortStops(data) {
    for(let i = 0; i < data.length; i++) {
      if(data[i].stops.length === 3) {
        if(data[i].stops[0].type === 'DO') {
          data[i].stops = [
            data[i].stops[1],
            data[i].stops[2],
            data[i].stops[0]
          ];
        }
        // check again now if second stop is also drop off (reading 0 index because 1 has been shifted to 0 above)
        if(data[i].stops[0].type === 'DO') {
          data[i].stops = [
            data[i].stops[1],
            data[i].stops[2],
            data[i].stops[0]
          ];
        }
      }
      else if(data[i].stops.length === 2) {
        if(data[i].stops[0].type === 'DO') {
          data[i].stops = [
            data[i].stops[1],
            data[i].stops[0]
          ];
        }
      }
    }
    return data;
  }

  findSeats(e) {
    e.preventDefault();
    this.setState({ loading: true, noSchedule: false });
    const { departDate, departCity, arriveCity } = this.state;
    if (departDate && departCity) {
      let data = {
        departCity: departCity,
        departDate: moment(departDate).format('YYYY-MM-DD'),
        arriveCity: arriveCity
      }
      mainService.getMain(data)
      .then(data => {
        this.setState({ loading: false });
        console.log(data)
        if(data && data.schedules.length > 0) {
          let schedules = this.sortStops(data.schedules);
          schedules = _.orderBy(schedules, (item) => {
            return moment(item.stops[0].time, 'HH:mm:ss');
          });
          schedules = _.orderBy(schedules, (item) => {
            return item.deleted;
          });
          this.setState({openSchedule: true, schedules: schedules, openBook: false, customAmount: ''});
        }
        else {
          this.setState({noSchedule: true});
        }
      })
      .catch(err => {
        console.log(err);
        this.setState({error: err, loading: false});
      })
    }
    else {
      return false;
    }
  }

  toggleField(e) {
    let name = e.target.name;
    let fields = this.state.fields;
    if(this.state.fields[name]) {
      fields[name] = false;
      this.setState({fields: fields});
    }
    else {
      fields[name] = true;
      this.setState({fields: fields});
    }
  }

  componentDidUpdate(prevProps) {
    if(this.props.error) {
      this.props.addNotification({type: 'error', message: this.props.error});
    }
    if(this.props.location.search && this.props.location.search !== prevProps.location.search) {
      window.location.reload();
    }
  }

  getCityLabel(city) {
    if(!city) {
      return '';
    }
    const stop = _.find(this.props.stops || [], {city: city});
    return stop ? stop.label : city;
  }

  componentDidMount() {
    this.props.dispatch(stopActions.getStops({}));
    if(this.props.location.search && queryStringToJSON(this.props.location.search).column && queryStringToJSON(this.props.location.search).value) {
      let criteria = {[queryStringToJSON(this.props.location.search).column] : queryStringToJSON(this.props.location.search).value};
      criteria.skip = 0;
      this.setState({criteria: criteria});
      this.props.dispatch(reservationActions.searchReservations(criteria));
    }
    let years = [];
    let start = new Date().getFullYear();
    let end = start + 11;
    for (let i = start; i < end; i++) {
      years.push(i.toString().substr(2));
    }
    this.setState({ years: years });
    document.getElementById('infinite-scroller').onscroll = _.debounce(() => {
      if (this.props.loading || !this.state.hasMore) {
        return;
      }
      var style = window.getComputedStyle(document.getElementById('infinite-scroller'), null);
      var innerHeight = parseInt(style.getPropertyValue("height"), 10);
      if (
        innerHeight + document.getElementById('infinite-scroller').scrollTop
        >= document.getElementById('infinite-scroller-body').offsetHeight
      ) {
        this.loadMoreReservations();
      }
    }, 100);
    window.addEventListener('beforeunload', this._handleBeforeUnload);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this._handleBeforeUnload);
    scheduleService.releaseAllHolds(getSessionId())
      .catch(function(err) { console.error('[releaseAllHolds unmount]', err); });
  }

  _handleBeforeUnload() {
    const sessionId = getSessionId();
    const url = `${config.apiUrl}/schedule/seats/hold/session`;
    const xhr = new XMLHttpRequest();
    xhr.open('DELETE', url, false);
    xhr.setRequestHeader('Content-Type', 'application/json');
    try {
      xhr.send(JSON.stringify({ session_id: sessionId }));
    } catch (_e) {
      // Best-effort; holds expire after 2 minutes
    }
  }

  loadMoreReservations() {
    if(this.props.location.search && queryStringToJSON(this.props.location.search).column && queryStringToJSON(this.props.location.search).value) {
      if(this.props.mainItems && ((this.props.mainItems.length % 50) !== 0)) {
        this.setState({hasMore: false});
        return;
      }
      let criteria = {[queryStringToJSON(this.props.location.search).column] : queryStringToJSON(this.props.location.search).value};
      criteria.skip = this.props.mainItems ? this.props.mainItems.length : 0;
      criteria.append = true;
      this.setState({criteria: criteria});
      this.props.dispatch(reservationActions.searchReservations(criteria));
    }
  }

  getCityCode(city) {
    const stop = _.find(this.props.stops || [], {city: city});
    return stop ? stop.code : '';
  }

  deleteItem = ids => {
    confirmAlert({
      title: 'Confirm to delete',
      message: 'Are you sure to do this?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.props.dispatch(reservationActions.deleteReservations(ids))
        },
        {
          label: 'No',
          onClick: () => ''
        }
      ]
    });
  }

  addParams() {
    return this.props.location.search;
  }

  showNotes(reservation) {
    let data = {
      reservation: reservation,
      date: reservation.slot,
      time: reservation.depart_stop.time,
      stop: reservation.depart_stop.stop.address
    };
    this.setState({openNotes: true, notesData: data});
  }

  closeNotes() {
    this.setState({openNotes: false, notesData: null});
  }

  showActionDetails(action) {
    this.setState({openActionDetails: true, actionRecord: action});
  }

  closeActionDetails() {
    this.setState({openActionDetails: false, actionRecord: null});
  }

  proceed() {
    if(this.state.selected.length > 0) {
      if(this.state.action === 'delete') {
        this.deleteItem(this.state.selected);
      }
      else if(this.state.action === 'email') {
        this.setState({loading: true});
        mainService.sendConfirmationMail({id: this.state.selected})
        .then(result => {
          this.setState({openSentSuccess: true, loading: false, bulkActionInfo: result.message});
        })
        .catch(err => {
          this.setState({loading: false});
          console.log(err);
        })
      }
      else if(this.state.action === 'customEmail') {
        if(!this.state.subject || !this.state.body) {
          return;
        }
        this.setState({loading: true});
        mainService.sendCustomMail({id: this.state.selected, subject: this.state.subject, message: this.state.body})
        .then(result => {
          this.setState({openSentSuccess: true, loading: false, bulkActionInfo: result.message});
        })
        .catch(err => {
          this.setState({loading: false});
          console.log(err);
        })
      }
      else if(this.state.action === 'text') {
        if(!this.state.text) {
          return;
        }
        this.setState({loading: true});
        mainService.sendCustomMessage({id: this.state.selected, text: this.state.text})
        .then(result => {
          this.setState({openSentSuccess: true, loading: false, bulkActionInfo: result.message});
        })
        .catch(err => {
          this.setState({loading: false});
          console.log(err);
        })
      }
      else if(this.state.action === 'customEmailAndText') {
        if(!this.state.subject || !this.state.body || !this.state.text) {
          return;
        }
        this.setState({loading: true});
        mainService.sendCustomMailAndMessage({id: this.state.selected, subject: this.state.subject, message: this.state.body, text: this.state.text})
        .then(result => {
          this.setState({openSentSuccess: true, loading: false, bulkActionInfo: result.message});
        })
        .catch(err => {
          this.setState({loading: false});
          console.log(err);
        })
      }
      else if(this.state.action === 'note') {
        if(!this.state.body) {
          return;
        }
        this.setState({loading: true});
        mainService.sendNote({id: this.state.selected, message: this.state.body})
        .then(result => {
          this.setState({openSentSuccess: true, loading: false});
        })
        .catch(err => {
          this.setState({loading: false});
          console.log(err);
        })
      }
      else if(this.state.action === 'checked') {
        this.setState({loading: true});
        mainService.markCheckedIn({id: this.state.selected})
        .then(result => {
          this.setState({openSentSuccess: true, loading: false});
        })
        .catch(err => {
          this.setState({loading: false});
          console.log(err);
        })
      }
      else if(this.state.action === 'complimentaryAll') {
        if(!this.state.body) {
          return;
        }
        this.setState({loading: true});
        mainService.complimentaryAll({id: this.state.selected, message: this.state.body})
        .then(result => {
          this.setState({openSentSuccess: true, loading: false, bulkActionInfo: result.message});
        })
        .catch(err => {
          this.setState({loading: false});
          console.log(err);
        })
      }
      else if(this.state.action === 'complimentaryOne') {
        if(!this.state.body) {
          return;
        }
        this.setState({loading: true});
        mainService.complimentaryOne({id: this.state.selected, message: this.state.body, credit: this.state.credit})
        .then(result => {
          this.setState({openSentSuccess: true, loading: false, bulkActionInfo: result.message});
        })
        .catch(err => {
          this.setState({loading: false});
          console.log(err);
        })
      }
      else if(this.state.action === 'complimentaryPartial') {
        if(!this.state.body) {
          return;
        }
        if(!this.state.credit) {
          return;
        }
        this.setState({loading: true});
        mainService.complimentaryPartial({id: this.state.selected, credit: this.state.credit, message: this.state.body})
        .then(result => {
          this.setState({openSentSuccess: true, loading: false, bulkActionInfo: result.message});
        })
        .catch(err => {
          this.setState({loading: false});
          console.log(err);
        })
      }
    }
  }

  closeSentSuccess() {
    this.setState({openSentSuccess: false, bulkActionInfo: ''});
    this.props.dispatch(reservationActions.searchReservations(this.state.criteria));
  }

  closeUpdateSuccess() {
    this.setState({openUpdateSuccess: false});
    this.props.dispatch(reservationActions.searchReservations(this.state.criteria));
  }

  getSeatsOptions() {
    let arr = [];
    if(!this.state.selectedLeg) {
      return arr;
    }
    for(let i = 1; i <= this.state.selectedLeg.active; i++) {
      arr.push({label: i, value: i});
    }
    return arr;
  }

  getRecordsSummary(leg) {
    let arr = [];
    if(leg.action_records && leg.action_records.length > 0) {
      for(let i = 0; i < leg.action_records.length; i++) {
        arr.push(leg.action_records[i].type + ': ' + moment(leg.action_records[i].created_at).format('MM/DD/YY') + ' at ' + moment(leg.action_records[i].created_at).format('hh:mm A'));
      }
    }
    return arr;
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true, error: '', code: '' });
    if (this.state.showRescheduleSeatSelection && this.state.rescheduleSelectedSeats.length === 0 && !this.state.skipSeatSelection) {
      this.setState({ error: 'Please select at least one seat, or tick "Skip seat assignment" to proceed without assigning seats.' });
      return;
    }
    let data = {
      waiveDifference: this.state.waiveDifference,
      reservationNumber: this.state.selectedLeg.reservationNumber,
      schedule_bus: this.state.schedules[this.state.selectedBus].schedule_bus,
      date: moment(this.state.departDate).format('YYYY-MM-DD'),
      status: 'active',
      slot: this.state.slot,
      departCity: this.state.departCity,
      departCityCode: this.getCityCode(this.state.departCity),
      arriveCity: this.state.arriveCity,
      seats: parseInt(this.state.seatsToReschedule, 10),
      // Admin picks which seated tickets move; the rest of the count is covered by unassigned tickets
      oldSeatNumbers: (this.state.rescheduleOldSeatNumbers || []).slice().sort(),
      oldUnassignedCount: Math.max(0, (parseInt(this.state.seatsToReschedule, 10) || 0) - (this.state.rescheduleOldSeatNumbers || []).length),
      email: this.state.selectedLeg.user.email,
      paymentMethod: this.state.paymentMethod,
      depart_stop: this.state.departStop,
      arrive_stop: this.state.arriveStop,
      amount: this.getAmount(),
      payment: this.getAmount(),
      remark: this.state.remark,
      price: this.state.selectedRoutePrice,
      pricePerSeat: (!this.state.customAmount ? this.state.selectedRoutePrice : (this.getActiveReservations(this.state.selectedLeg.reservations)[0].order_item.amount + (parseInt(this.state.customAmount, 10)/parseInt(this.state.seatsToReschedule, 10)))),
      letter: this.state.schedules[this.state.selectedBus].letter,
      customAmount: parseInt(this.state.customAmount, 10),
      credits: 0,
      points: 0,
    }
    if(this.getCredits()) {
      data.credits = this.getCredits();
      if(this.getCredits() < this.getAmount()) {
        data.payment = this.getAmount() - this.getCredits();
      }
      else {
        data.payment = 0;
      }
    }
    // pointsAmount can be > 0 with 0 ADDITIONAL points (same-type flat transfer) — gate on either
    if((this.getRequiredPoints().points > 0 || this.getRequiredPoints().pointsAmount > 0) && this.getRequiredPoints().points <= this.state.selectedLeg.user.points) {
      data.points = this.getRequiredPoints().points;
      data.pointsAmount = this.getRequiredPoints().pointsAmount;
      if(this.getRequiredPoints().pointsAmount < this.getAmount()) {
        data.payment = this.getAmount() - this.getRequiredPoints().pointsAmount;
      }
      else {
        data.payment = 0;
      }
    }
    if(!data.payment && this.getActiveReservations(this.state.selectedLeg.reservations)[0].vouchers) {
      data.paymentMethod = 'Tripperbus Points';
    }
    if(!data.payment && (this.getActiveReservations(this.state.selectedLeg.reservations)[0].credit || this.getActiveReservations(this.state.selectedLeg.reservations)[0].paid)) {
      data.paymentMethod = 'Tripperbus Credits';
    }
    if(this.state.paymentMethod === 'card' && data.payment) {
      if(!this.state.number || !this.state.cvv || !this.state.month || !this.state.year) {
        this.setState({ error: 'Enter the card number, expiry and security code to charge the difference of ' + numeral(data.payment).format('$0.00') + '.' });
        return;
      }
      data.number = this.state.number.split('-').join('');
      data.cvv = this.state.cvv;
      data.expiryDate = '' + this.state.month + '' + this.state.year;
      data.cardHolder = this.state.cardHolder || (this.state.selectedLeg.user.firstName + ' ' + this.state.selectedLeg.user.lastName);
      data.paymentMethod = 'card';
    }
    if(this.state.paymentMethod !== 'card' && data.paymentMethod !== 'Tripperbus Credits' && data.paymentMethod !== 'Tripperbus Points') {
      data.credits = 0;
      data.payment = 0;
      data.points = 0;
    }
    if (this.state.rescheduleSelectedSeats.length > 0) {
      const busType = this.getRescheduleBusType();
      const basePrice = this.state.selectedRoutePrice || 0;
      const tiers = this.state.reschedulePricingTiers;
      const seatItems = [];
      for (let i = 0; i < this.state.rescheduleSelectedSeats.length; i++) {
        const seatId = this.state.rescheduleSelectedSeats[i];
        const seatPrice = getSeatPrice(seatId, basePrice, busType, tiers);
        seatItems.push({
          seat_number: seatId,
          price: seatPrice,
          addonAmount: seatPrice - basePrice,
        });
      }
      data.seatSelections = seatItems;
      data.session_id = getSessionId();
    }
    this.setState({loading: true, error: ''});
    console.log(data);
    reservationService.rescheduleMainReservation(data)
    .then(result => {
      console.log(result);
      scheduleService.releaseAllHolds(getSessionId())
        .catch(function(err) { console.error('[releaseAllHolds submit]', err); });
      this.setState({loading: false, code: result.departTripCode, openSuccess: true, customAmount: '', rescheduleSelectedSeats: [], reschedulePendingSeats: [], reschedulePendingReleaseSeats: [], showRescheduleSeatSelection: false, skipSeatSelection: false});
    })
    .catch(err => {
      console.log(err);
      // Always surface a string — an object here renders as nothing and the button looks dead
      let msg = typeof err === 'string' ? err : ((err && (err.message || err.error)) || 'Reschedule failed — the server rejected the request. Check the backend logs for details.');
      if (msg.indexOf('prices have changed') > -1 || msg.indexOf('no longer available') > -1) {
        this.handleRefreshRescheduleSeats();
        this.setState({loading: false, error: msg + ' The seat map and prices above have been refreshed — please review and click Reschedule again.'});
        return;
      }
      this.setState({loading: false, error: msg});
    });
  }

  closeSuccess() {
    window.location.reload();
  }

  toggleSelectAll(e) {
    if(e.target.checked) {
      let selected = [];
      (this.props.mainItems || []).map(item => {
        selected.push(item.id);
        return item;
      });
      this.setState({selected: selected});
    }
    else {
      this.setState({selected: []});
    }
  }

  toggleSelect(id) {
    let selected = this.state.selected;
    let index = this.state.selected.indexOf(id);
    if(index === -1) {
      selected.push(id);
    }
    else {
      selected.splice(index, 1);
    }
    this.setState({selected: selected});
  }

  handleSeatsChange(e) {
    const update = {[e.target.name]: e.target.value};
    if (e.target.name === 'seatsToReschedule') {
      // Default the old-ticket picker to seatless-first: only pre-pick seats when unassigned
      // tickets can't cover the requested count
      update.rescheduleOldSeatNumbers = this.getDefaultRescheduleOldSeats(parseInt(e.target.value, 10) || 0);
    }
    this.setState(update);
  }

  getRescheduleSelectionInfo() {
    const active = this.state.selectedLeg ? this.getActiveReservations(this.state.selectedLeg.reservations) : [];
    const assignedSeats = active.map(r => r.seat_number).filter(Boolean).sort();
    const seatlessCount = active.length - assignedSeats.length;
    const count = parseInt(this.state.seatsToReschedule, 10) || 0;
    const chosen = this.state.rescheduleOldSeatNumbers || [];
    const unassignedUsed = count - chosen.length;
    const forcedMin = Math.max(0, count - seatlessCount);
    const valid = count > 0 && chosen.length <= count && unassignedUsed >= 0 && unassignedUsed <= seatlessCount;
    return { assignedSeats, seatlessCount, count, chosen, unassignedUsed, forcedMin, valid };
  }

  getDefaultRescheduleOldSeats(count) {
    const active = this.state.selectedLeg ? this.getActiveReservations(this.state.selectedLeg.reservations) : [];
    const assignedSeats = active.map(r => r.seat_number).filter(Boolean).sort();
    const seatlessCount = active.length - assignedSeats.length;
    return assignedSeats.slice(0, Math.max(0, count - seatlessCount));
  }

  // The actual rows being rescheduled, in the same order the backend resolves them
  // (orders.js reschedule): explicitly picked seats first, then unassigned tickets. With no
  // picks it mirrors the backend's count-based fallback — unassigned tickets move first.
  // Pricing must read these rows, not the first N of the leg.
  getRescheduleMovingReservations() {
    const active = this.state.selectedLeg ? this.getActiveReservations(this.state.selectedLeg.reservations) : [];
    const count = parseInt(this.state.seatsToReschedule, 10) || 0;
    if(!count) {
      return [];
    }
    const chosen = this.state.rescheduleOldSeatNumbers || [];
    if(chosen.length > 0) {
      const assigned = active.filter((r) => chosen.indexOf(r.seat_number) !== -1);
      const unassigned = active.filter((r) => !r.seat_number).slice(0, Math.max(0, count - assigned.length));
      return assigned.concat(unassigned);
    }
    return active.filter((r) => !r.seat_number).concat(active.filter((r) => r.seat_number)).slice(0, count);
  }

  toggleRescheduleOldSeat(seat) {
    this.setState((prevState) => {
      const current = prevState.rescheduleOldSeatNumbers || [];
      const updated = current.indexOf(seat) !== -1
        ? current.filter((s) => s !== seat)
        : current.concat([seat]).sort();
      return { rescheduleOldSeatNumbers: updated };
    });
  }

  checkSelected(id) {
    let index = this.state.selected.indexOf(id);
    if(index > -1) {
      return true;
    }
    return false;
  }

  cancel(leg) {
    this.setState({openCancel: true, selectedLeg: leg, cancelSeatCount: '', showCancelSeatGrid: false, cancelSeatNumbers: []}, () => {
      this.fetchCancelSeatInfo(leg);
    });
    if (leg.otherLeg) {
      reservationService.getLegByNumber(leg.otherLeg)
      .then(result => {
        const copy = JSON.parse(JSON.stringify(this.state.selectedLeg || leg));
        copy.otherLeg = result.data;
        copy.otherLeg.user = leg.user;
        this.setState({ selectedLeg: copy });
      })
      .catch(err => {
        console.log(err);
      });
    }
  }

  closeCancel() {
    this.setState({openCancel: false, selectedLeg: null, seatsToCancel: '', cancelSeatNumbers: [], cancelUnassignedCount: 0, cancelBusLayout: null, cancelTakenSeats: [], cancelSeatInfoLoading: false, cancelSeatCount: '', showCancelSeatGrid: false});
  }

  proceedToCancelSeatGrid() {
    const count = parseInt(this.state.cancelSeatCount, 10);
    if (!count || !this.state.selectedLeg) {
      return;
    }
    const userSeats = this.getSeatNumbersForLeg(this.state.selectedLeg);
    const preSelected = userSeats.slice(0, count);
    this.setState({ showCancelSeatGrid: true, cancelSeatNumbers: preSelected, seatsToCancel: preSelected.length });
  }

  reschedule(leg) {
    let stop = {
      address: leg.depart_stop.stop.address,
      time: leg.depart_stop.time,
      id: leg.depart_stop.id
    };

    let fullName = leg.firstName + ' ' + leg.lastName;

    this.setState({openReschedule: true, seatsToReschedule: '', rescheduleOldSeatNumbers: [], selectedLeg: leg, selectedStop: stop, credits: 0, points: 0, pointsAmount: 0, selectedBus: null, departStop: null, arriveStop: null, cardHolder: fullName});

    if(leg.otherLeg) {
      reservationService.getLegByNumber(leg.otherLeg)
      .then(result => {
        const copy = JSON.parse(JSON.stringify(leg));
        copy.otherLeg = result.data;
        copy.otherLeg.user = leg.user;
        this.setState({selectedLeg: copy});
      })
      .catch(err => {
        console.log(err);
      });
    }
  }

  switchLeg(leg, otherLeg) {
    let stop = {
      address: leg.depart_stop.stop.address,
      time: leg.depart_stop.time,
      id: leg.depart_stop.id
    };
    leg.otherLeg = otherLeg;
    this.setState({openReschedule: true, seatsToReschedule: '', rescheduleOldSeatNumbers: [], selectedLeg: leg, selectedStop: stop, credits: 0, points: 0, selectedBus: null, departStop: null, arriveStop: null});
  }

  switchCancelLeg(leg, otherLeg) {
    leg.otherLeg = otherLeg;
    this.setState({openCancel: true, selectedLeg: leg, cancelSeatNumbers: [], cancelBusLayout: null, cancelTakenSeats: [], cancelSeatInfoLoading: false, cancelSeatCount: '', showCancelSeatGrid: false}, () => {
      this.fetchCancelSeatInfo(leg);
    });
  }

  closeReschedule() {
    this.setState({openReschedule: false, selectedLeg: null, seatsToReschedule: '', rescheduleOldSeatNumbers: [], waiveDifference: false, selectedStop: null, selectedBus: null});
  }

  closeSchedule() {
    this.setState({openSchedule: false, selectedLeg: null, seatsToReschedule: '', rescheduleOldSeatNumbers: [], waiveDifference: false, selectedStop: null, openReschedule: false, selectedBus: null, rescheduleSelectedSeats: [], reschedulePendingSeats: [], reschedulePendingReleaseSeats: [], showRescheduleSeatSelection: false, skipSeatSelection: false, rescheduleTakenSeats: [], rescheduleTempTakenSeats: [], reschedulePricingTiers: []});
    scheduleService.releaseAllHolds(getSessionId())
      .catch(function(err) { console.error('[releaseAllHolds closeSchedule]', err); });
  }

  getSeatNumbersForLeg(res) {
    if (!res.reservations || !Array.isArray(res.reservations)) {
      return [];
    }
    return res.reservations
      .filter((r) => r.status === 'active')
      .map((r) => (r.seat_number != null ? r.seat_number : (r.order_item && r.order_item.seat_number)))
      .filter(Boolean);
  }

  fetchCancelSeatInfo(leg) {
    const userSeats = this.getSeatNumbersForLeg(leg);
    if (!userSeats.length || !leg.schedule_bus) {
      return;
    }
    const scheduleBusId = typeof leg.schedule_bus === 'object' ? leg.schedule_bus.id : leg.schedule_bus;
    this.setState({ cancelSeatInfoLoading: true });
    scheduleService.getSeatInfo(scheduleBusId, leg.slot)
      .then((data) => {
        this.setState({
          cancelSeatInfoLoading: false,
          cancelBusLayout: (data && data.busLayout) || null,
          cancelTakenSeats: (data && data.takenSeats) || [],
        });
      })
      .catch((err) => {
        console.error('[fetchCancelSeatInfo]', err);
        this.setState({ cancelSeatInfoLoading: false });
      });
  }

  handleCancelSeatToggle(seatId) {
    if (!this.state.selectedLeg) {
      return;
    }
    const userSeats = this.getSeatNumbersForLeg(this.state.selectedLeg);
    if (userSeats.indexOf(seatId) === -1) {
      return;
    }
    this.setState((prevState) => {
      const current = prevState.cancelSeatNumbers;
      const updated = current.indexOf(seatId) !== -1
        ? current.filter((s) => s !== seatId)
        : current.concat([seatId]);
      return { cancelSeatNumbers: updated, seatsToCancel: updated.length || '' };
    });
  }

  getAllSeatIdsFromLayout(busLayout) {
    if (!busLayout || !busLayout.columns || !busLayout.totalRows) {
      return [];
    }
    const ids = [];
    for (let row = 1; row <= busLayout.totalRows; row++) {
      for (let c = 0; c < busLayout.columns.length; c++) {
        const id = String(row) + busLayout.columns[c];
        const special = busLayout.specialCells ? busLayout.specialCells[id] : null;
        if (!special || special.type === 'seat') {
          ids.push(id);
        }
      }
    }
    return ids;
  }

  getUnassignedCountForLeg(res) {
    if (!res.reservations || !Array.isArray(res.reservations)) return 0;
    const active = res.reservations.filter((r) => r.status === 'active');
    const assigned = active.filter((r) => r.seat_number != null);
    return active.length - assigned.length;
  }

  openManageSeatsModal(leg) {
    const hasAssigned = this.getSeatNumbersForLeg(leg).length > 0;
    const unassigned = this.getUnassignedCountForLeg(leg);
    const defaultTab = hasAssigned ? 'switch' : 'assign';
    this.setState({
      openManageSeats: true, selectedLeg: leg, manageSeatTab: defaultTab,
      switchStep: 1, seatsToSwitch: [], switchMappings: {}, switchActiveIndex: 0, switchPriceDiff: 0,
      switchLoading: false, switchBusLayout: null, switchMaxSelectableRow: null, switchTakenSeats: [], switchTemporaryTakenSeats: [],
      switchSeatInfoLoading: false, switchPendingSeats: [], switchPendingReleaseSeats: [], switchPaymentMethod: 'none', switchHoldError: null,
      assignSelectedSeats: [], assignMaxSeats: unassigned, assignPendingSeats: [], assignPendingReleaseSeats: [], applyCredits: false,
      cancelAddonSeats: [], cancelAddonLoading: false,
      cardHolder: '', number: '', month: '', year: '', cvv: '', switchCardErrors: {},
      manageSeatSuccess: null,
    }, () => {
      this.fetchSwitchSeatInfo(leg);
    });
  }

  closeManageSeatsModal() {
    const shouldReload = !!this.state.manageSeatSuccess;
    scheduleService.releaseAllHolds(getSessionId()).catch(() => {});
    this.setState({
      openManageSeats: false, selectedLeg: null, manageSeatTab: 'switch',
      switchStep: 1, seatsToSwitch: [], switchMappings: {}, switchActiveIndex: 0, switchPriceDiff: 0,
      switchLoading: false, switchBusLayout: null, switchMaxSelectableRow: null, switchTakenSeats: [], switchTemporaryTakenSeats: [],
      switchSeatInfoLoading: false, switchPendingSeats: [], switchPendingReleaseSeats: [], switchPaymentMethod: 'none', switchHoldError: null,
      assignSelectedSeats: [], assignMaxSeats: 0, assignPendingSeats: [], assignPendingReleaseSeats: [], applyCredits: false,
      cancelAddonSeats: [], cancelAddonLoading: false,
      switchCardErrors: {}, manageSeatSuccess: null,
    }, () => {
      if (shouldReload) window.location.reload();
    });
  }

  handleManageSeatTabChange = (tabKey) => {
    if (tabKey === this.state.manageSeatTab) return;
    scheduleService.releaseAllHolds(getSessionId()).catch(() => {});
    this.setState({
      manageSeatTab: tabKey,
      switchStep: 1, seatsToSwitch: [], switchMappings: {}, switchActiveIndex: 0, switchHoldError: null, switchPendingSeats: [], switchPendingReleaseSeats: [],
      assignSelectedSeats: [], assignPendingSeats: [], assignPendingReleaseSeats: [],
      cancelAddonSeats: [],
      applyCredits: false, switchPaymentMethod: 'none',
      cardHolder: '', number: '', month: '', year: '', cvv: '', switchCardErrors: {},
    }, () => {
      this.fetchSwitchSeatInfo(this.state.selectedLeg);
    });
  }

  handleCancelAddonSeatToggle = (seatId) => {
    if (!this.state.selectedLeg) return;
    const userSeats = this.getSeatNumbersForLeg(this.state.selectedLeg);
    if (userSeats.indexOf(seatId) === -1) return;
    this.setState((prevState) => {
      const current = prevState.cancelAddonSeats;
      const updated = current.indexOf(seatId) !== -1
        ? current.filter((s) => s !== seatId)
        : current.concat([seatId]);
      return { cancelAddonSeats: updated };
    });
  }

  proceedCancelAddon() {
    if (!this.state.cancelAddonSeats.length || !this.state.selectedLeg) return;
    const seats = this.state.cancelAddonSeats.slice();
    this.setState({cancelAddonLoading: true});
    reservationService.cancelSeatAddon(
      this.state.selectedLeg.reservationNumber,
      seats
    )
    .then(() => {
      this.setState({ cancelAddonLoading: false, manageSeatSuccess: 'Seat assignment removed (' + seats.join(', ') + '). Close this modal to refresh.' });
    })
    .catch((err) => {
      console.error('[cancelSeatAddon]', err);
      const msg = serverErrorMessage(err, 'Remove failed. Please try again.');
      this.setState({ cancelAddonLoading: false, switchHoldError: msg });
    });
  }

  silentFetchSwitchSeatInfo() {
    if (this.state.selectedLeg) {
      this._fetchSwitchSeatInfoInternal(this.state.selectedLeg, false);
    }
  }

  fetchSwitchSeatInfo(leg) {
    this._fetchSwitchSeatInfoInternal(leg, true);
  }

  _fetchSwitchSeatInfoInternal(leg, showLoading) {
    const scheduleBusId = typeof leg.schedule_bus === 'object' ? leg.schedule_bus.id : leg.schedule_bus;
    const sessionId = getSessionId();
    if (showLoading) this.setState({ switchSeatInfoLoading: true });

    if (leg.reservationNumber) {
      reservationService.getLegByNumber(leg.reservationNumber)
        .then((result) => {
          if (result && result.data && result.data.reservations) {
            this.setState((prevState) => {
              if (!prevState.selectedLeg) return null;
              const updated = Object.assign({}, prevState.selectedLeg, { reservations: result.data.reservations });
              return { selectedLeg: updated };
            });
          }
        })
        .catch(() => {});
    }

    scheduleService.getSeatInfo(scheduleBusId, leg.slot, sessionId)
      .then((data) => {
        const newTaken = (data && data.takenSeats) || [];
        const newTempTaken = (data && data.temporaryTakenSeats) || [];
        const unavailable = newTaken.concat(newTempTaken);

        this.setState((prevState) => {
          const updates = {
            switchSeatInfoLoading: false,
            switchBusLayout: (data && data.busLayout) || null,
            switchMaxSelectableRow: (data && data.maxSelectableRow != null) ? data.maxSelectableRow : null,
            switchTakenSeats: newTaken,
            switchTemporaryTakenSeats: newTempTaken,
            switchPricingTiers: (data && data.pricing && data.pricing.tiers) || [],
            switchBasePrice: (data && data.pricing && data.pricing.basePrice) || 0,
          };

          if (prevState.switchStep === 2 && prevState.switchMappings) {
            const newMappings = Object.assign({}, prevState.switchMappings);
            let changed = false;
            Object.keys(newMappings).forEach((key) => {
              if (newMappings[key] && unavailable.indexOf(newMappings[key]) !== -1) {
                newMappings[key] = null;
                changed = true;
              }
            });
            if (changed) updates.switchMappings = newMappings;
          }

          if (prevState.assignSelectedSeats && prevState.assignSelectedSeats.length > 0) {
            const validAssign = prevState.assignSelectedSeats.filter((s) => unavailable.indexOf(s) === -1);
            if (validAssign.length !== prevState.assignSelectedSeats.length) {
              updates.assignSelectedSeats = validAssign;
            }
          }

          return updates;
        });
      })
      .catch((err) => {
        console.error('[fetchSwitchSeatInfo]', err);
        this.setState({ switchSeatInfoLoading: false });
      });
  }

  handleAssignSeatSelect = (seatId) => {
    if (!this.state.selectedLeg) return;
    const userSeats = this.getSeatNumbersForLeg(this.state.selectedLeg);
    if (userSeats.indexOf(seatId) !== -1) return;

    if (this.state.assignPendingSeats.length > 0 || this.state.assignPendingReleaseSeats.length > 0) return;

    const selected = this.state.assignSelectedSeats;
    const scheduleBusId = typeof this.state.selectedLeg.schedule_bus === 'object' ? this.state.selectedLeg.schedule_bus.id : this.state.selectedLeg.schedule_bus;
    const slot = this.state.selectedLeg.slot;
    const sessionId = getSessionId();

    if (selected.indexOf(seatId) !== -1) {
      this.setState((prevState) => ({
        assignSelectedSeats: prevState.assignSelectedSeats.filter((s) => s !== seatId),
        assignPendingReleaseSeats: prevState.assignPendingReleaseSeats.concat([seatId])
      }));
      scheduleService.releaseSeat(scheduleBusId, slot, seatId, sessionId)
        .then(() => {
          this.setState((prevState) => ({
            assignPendingReleaseSeats: prevState.assignPendingReleaseSeats.filter((s) => s !== seatId)
          }));
          this.silentFetchSwitchSeatInfo();
        })
        .catch((err) => {
          console.error('[releaseSeat assign]', err);
          this.setState((prevState) => ({
            assignPendingReleaseSeats: prevState.assignPendingReleaseSeats.filter((s) => s !== seatId)
          }));
        });
    } else {
      if (selected.length >= this.state.assignMaxSeats) return;
      this.setState((prevState) => ({
        assignSelectedSeats: prevState.assignSelectedSeats.concat([seatId]),
        assignPendingSeats: prevState.assignPendingSeats.concat([seatId])
      }));
      scheduleService.holdSeat(scheduleBusId, slot, seatId, sessionId)
        .then(() => {
          this.setState((prevState) => ({
            assignPendingSeats: prevState.assignPendingSeats.filter((s) => s !== seatId)
          }));
        })
        .catch((err) => {
          if (err && err.status === 409) {
            const freshTempSeats = err.temporaryTakenSeats || null;
            const freshTakenSeats = err.takenSeats || null;
            this.setState((prevState) => {
              const update = {
                assignSelectedSeats: prevState.assignSelectedSeats.filter((s) => s !== seatId),
                assignPendingSeats: prevState.assignPendingSeats.filter((s) => s !== seatId),
              };
              if (freshTempSeats) update.switchTemporaryTakenSeats = freshTempSeats;
              if (freshTakenSeats) update.switchTakenSeats = freshTakenSeats;
              return update;
            });
            if (!freshTempSeats && !freshTakenSeats) {
              this.fetchSwitchSeatInfo(this.state.selectedLeg);
            }
          } else {
            this.setState((prevState) => ({
              assignPendingSeats: prevState.assignPendingSeats.filter((s) => s !== seatId)
            }));
          }
          console.error('[holdSeat assign]', err);
        });
    }
  }

  handleSwitchSelectToggle = (seatId) => {
    if (!this.state.selectedLeg) return;
    const userSeats = this.getSeatNumbersForLeg(this.state.selectedLeg);
    if (userSeats.indexOf(seatId) === -1) return;
    this.setState((prevState) => {
      const seats = prevState.seatsToSwitch;
      const updated = seats.indexOf(seatId) !== -1
        ? seats.filter((s) => s !== seatId)
        : seats.concat([seatId]);
      return { seatsToSwitch: updated };
    });
  }

  handleSwitchMapSeat = (seatId) => {
    const seatsToSwitch = this.state.seatsToSwitch;
    if (!seatsToSwitch.length) return;
    const userSeats = this.getSeatNumbersForLeg(this.state.selectedLeg);
    if (userSeats.indexOf(seatId) !== -1) return;
    const leg = this.state.selectedLeg;
    const scheduleBusId = typeof leg.schedule_bus === 'object' ? leg.schedule_bus.id : leg.schedule_bus;
    const sessionId = getSessionId();

    if (this.state.switchPendingSeats.length > 0 || this.state.switchPendingReleaseSeats.length > 0) return;

    const existingKey = Object.keys(this.state.switchMappings).find((k) => this.state.switchMappings[k] === seatId);
    if (existingKey) {
      this.setState((prevState) => {
        const newMappings = Object.assign({}, prevState.switchMappings);
        newMappings[existingKey] = null;
        return { switchMappings: newMappings, switchPendingReleaseSeats: prevState.switchPendingReleaseSeats.concat([seatId]) };
      });
      scheduleService.releaseSeat(scheduleBusId, leg.slot, seatId, sessionId)
        .then(() => {
          this.setState((prevState) => ({
            switchPendingReleaseSeats: prevState.switchPendingReleaseSeats.filter((s) => s !== seatId)
          }));
          this.silentFetchSwitchSeatInfo();
        })
        .catch((err) => {
          console.error('[releaseSeat switch]', err);
          this.setState((prevState) => ({
            switchPendingReleaseSeats: prevState.switchPendingReleaseSeats.filter((s) => s !== seatId)
          }));
        });
    } else {
      const unmapped = seatsToSwitch.find((s) => !this.state.switchMappings[s]);
      if (!unmapped) return;
      const previousTarget = this.state.switchMappings[unmapped];
      if (previousTarget) {
        scheduleService.releaseSeat(scheduleBusId, leg.slot, previousTarget, sessionId).catch(() => {});
      }
      this.setState((prevState) => {
        const newMappings = Object.assign({}, prevState.switchMappings);
        newMappings[unmapped] = seatId;
        return { switchMappings: newMappings, switchHoldError: null, switchPendingSeats: prevState.switchPendingSeats.concat([seatId]) };
      });
      scheduleService.holdSeat(scheduleBusId, leg.slot, seatId, sessionId)
        .then(() => {
          this.setState((prevState) => ({
            switchPendingSeats: prevState.switchPendingSeats.filter((s) => s !== seatId)
          }));
        })
        .catch((err) => {
          if (err && err.status === 409) {
            const freshTempSeats = err.temporaryTakenSeats || null;
            const freshTakenSeats = err.takenSeats || null;
            this.setState((prevState) => {
              const newMappings = Object.assign({}, prevState.switchMappings);
              const key = Object.keys(newMappings).find((k) => newMappings[k] === seatId);
              if (key) newMappings[key] = null;
              const update = {
                switchMappings: newMappings,
                switchHoldError: `Seat ${seatId.toUpperCase()} is no longer available. Seats have been refreshed.`,
                switchPendingSeats: prevState.switchPendingSeats.filter((s) => s !== seatId),
              };
              if (freshTempSeats) update.switchTemporaryTakenSeats = freshTempSeats;
              if (freshTakenSeats) update.switchTakenSeats = freshTakenSeats;
              return update;
            });
            if (!freshTempSeats && !freshTakenSeats) {
              this.fetchSwitchSeatInfo(this.state.selectedLeg);
            }
          } else {
            this.setState((prevState) => ({
              switchPendingSeats: prevState.switchPendingSeats.filter((s) => s !== seatId)
            }));
          }
        });
    }
  }

  validateSwitchCard() {
    const errors = {};
    const num = (this.state.number || '').replace(/-/g, '').replace(/\s/g, '');
    if (!this.state.cardHolder || !this.state.cardHolder.trim()) errors.cardHolder = 'Required';
    if (!num) errors.number = 'Required';
    else if (!/^\d{15,16}$/.test(num)) errors.number = 'Invalid card number';
    if (!this.state.month) errors.month = 'Required';
    if (!this.state.year) errors.year = 'Required';
    if (!this.state.cvv) errors.cvv = 'Required';
    else if (!/^\d{3,4}$/.test(this.state.cvv)) errors.cvv = 'Invalid CVV';
    this.setState({ switchCardErrors: errors });
    return Object.keys(errors).length === 0;
  }

  proceedSwitchSeat() {
    const seatsToSwitch = this.state.seatsToSwitch;
    const mappings = this.state.switchMappings;
    if (!this.state.selectedLeg) return;
    const allMapped = seatsToSwitch.every((s) => mappings[s]);
    if (!allMapped) return;

    this.setState({ switchLoading: true });
    const tiers = this.state.switchPricingTiers || [];
    const activeRes = this.state.selectedLeg ? this.getActiveReservations(this.state.selectedLeg.reservations) : [];

    const switches = seatsToSwitch.map((oldSeat) => {
      const newSeat = mappings[oldSeat];
      const oldRes = activeRes.find((r) => r.seat_number === oldSeat);
      const oldPrice = getPaidSeatValue(oldRes, oldSeat, tiers);
      const diff = getSeatPrice(newSeat, 0, null, tiers) - oldPrice;
      return { old_seat_number: oldSeat, new_seat_number: newSeat, priceDiff: diff };
    });

    let totalUpgrade = 0;
    let totalDowngrade = 0;
    switches.forEach((sw) => {
      if (sw.priceDiff > 0) totalUpgrade += sw.priceDiff;
      else if (sw.priceDiff < 0) totalDowngrade += Math.abs(sw.priceDiff);
    });
    const netAmount = totalUpgrade - totalDowngrade;

    const switchCustomerCredits = (this.state.selectedLeg && this.state.selectedLeg.user && this.state.selectedLeg.user.credits) || 0;
    const switchCreditsApplied = netAmount > 0 && this.state.applyCredits ? Math.min(switchCustomerCredits, netAmount) : 0;
    const switchRemaining = Math.max(netAmount - switchCreditsApplied, 0);

    const payload = {
      switches,
      credits: switchCreditsApplied,
      expectedNetAmount: netAmount,
      paymentMethod: switchRemaining > 0 ? this.state.switchPaymentMethod : (switchCreditsApplied > 0 ? 'credit' : 'none'),
    };

    if (switchRemaining > 0 && this.state.switchPaymentMethod === 'card') {
      if (!this.validateSwitchCard()) { this.setState({ switchLoading: false }); return; }
      payload.number = this.state.number.split('-').join('');
      payload.cvv = this.state.cvv;
      payload.expiryDate = '' + this.state.month + '' + this.state.year;
      payload.cardHolder = this.state.cardHolder;
      payload.paymentAmount = switchRemaining;
    }

    reservationService.switchSeat(this.state.selectedLeg.reservationNumber, payload)
      .then(() => {
        scheduleService.releaseAllHolds(getSessionId()).catch(() => {});
        const details = switches.map((sw) => sw.old_seat_number + ' → ' + sw.new_seat_number).join(', ');
        this.setState({ switchLoading: false, manageSeatSuccess: 'Seats switched successfully (' + details + '). Close this modal to refresh.' });
      })
      .catch((err) => {
        console.error('[switchSeat]', err);
        const msg = serverErrorMessage(err, 'Switch failed. Please try again.');
        this.setState({ switchLoading: false, switchHoldError: msg });
        this.fetchSwitchSeatInfo(this.state.selectedLeg);
      });
  }

  proceedAssignSeat() {
    if (!this.state.selectedLeg) return;
    const selected = this.state.assignSelectedSeats;
    if (!selected.length) return;

    this.setState({ switchLoading: true });
    const tiers = this.state.switchPricingTiers || [];

    const switches = selected.map((newSeat) => {
      const diff = getSeatPrice(newSeat, 0, null, tiers);
      return { old_seat_number: null, new_seat_number: newSeat, priceDiff: diff };
    });

    let totalUpgrade = 0;
    switches.forEach((sw) => {
      if (sw.priceDiff > 0) totalUpgrade += sw.priceDiff;
    });

    const customerCredits = (this.state.selectedLeg && this.state.selectedLeg.user && this.state.selectedLeg.user.credits) || 0;
    const creditsApplied = this.state.applyCredits ? Math.min(customerCredits, totalUpgrade) : 0;
    const remaining = Math.max(totalUpgrade - creditsApplied, 0);

    const payload = {
      switches,
      credits: creditsApplied,
      expectedNetAmount: totalUpgrade,
      paymentMethod: remaining > 0 ? this.state.switchPaymentMethod : (creditsApplied > 0 ? 'credit' : 'none'),
    };

    if (remaining > 0 && this.state.switchPaymentMethod === 'card') {
      if (!this.validateSwitchCard()) { this.setState({ switchLoading: false }); return; }
      payload.number = this.state.number.split('-').join('');
      payload.cvv = this.state.cvv;
      payload.expiryDate = '' + this.state.month + '' + this.state.year;
      payload.cardHolder = this.state.cardHolder;
      payload.paymentAmount = remaining;
    }

    reservationService.switchSeat(this.state.selectedLeg.reservationNumber, payload)
      .then((result) => {
        scheduleService.releaseAllHolds(getSessionId()).catch(() => {});
        // Report what the SERVER actually collected — it can be less than this screen estimated when
        // the ticket already carries seat value (e.g. a seat cleared by Move People)
        const charged = result && typeof result.totalCharged === 'number' ? result.totalCharged : null;
        const chargeNote = charged === null ? '' : (charged > 0 ? ' Charged $' + charged.toFixed(2) + '.' : ' No payment was due — the ticket already carried the seat value.');
        this.setState({ switchLoading: false, manageSeatSuccess: 'Seats assigned successfully (' + selected.join(', ') + ').' + chargeNote + ' Close this modal to refresh.' });
      })
      .catch((err) => {
        console.error('[assignSeat]', err);
        const msg = serverErrorMessage(err, 'Assign failed. Please try again.');
        this.setState({ switchLoading: false, switchHoldError: msg });
        this.fetchSwitchSeatInfo(this.state.selectedLeg);
      });
  }

  cancelEntireReservation() {
    if (!this.state.selectedLeg) return;
    this.setState({ loading: true });
    reservationService.cancelMainSeats(
      this.state.selectedLeg.reservationNumber,
      this.state.selectedLeg.total,
      this.state.selectedLeg.reservation_group,
      []
    )
    .then(() => {
      window.location.reload();
    })
    .catch((err) => {
      console.log(err);
      this.setState({ loading: false });
    });
  }

  proceedToCancel() {
    const seatCount = this.state.cancelSeatNumbers.length + (this.state.cancelUnassignedCount || 0);
    const count = seatCount || this.state.seatsToCancel;
    if (!count) {
      return;
    }
    this.setState({loading: true});
    reservationService.cancelMainSeats(
      this.state.selectedLeg.reservationNumber,
      count,
      this.state.selectedLeg.reservation_group,
      this.state.cancelSeatNumbers
    )
    .then(() => {
      window.location.reload();
    })
    .catch((err) => {
      console.log(err);
      this.setState({loading: false});
    });
  }

  proceedToReschedule() {
    if(this.state.seatsToReschedule) {
      this.setState({openBook: true, noSchedule: false});
    }
  }

  applyCredit() {
    let useCredit = this.getAmount() > this.state.selectedLeg.user.credits ? this.state.selectedLeg.user.credits : this.getAmount();
    this.setState({credits: useCredit, points: 0, pointsAmount: 0});
  }

  removeCredit() {
    this.setState({credits: 0});
  }

  applyPoints() {
    let requiredPoints = this.getRequiredPoints();
    this.setState({points: requiredPoints.points, pointsAmount: requiredPoints.pointsAmount, credits: 0});
  }

  removePoints() {
    this.setState({points: 0, pointsAmount: 0});
  }

  closeBook() {
    this.setState({openBook: false, openReschedule: false, selectedLeg: null, seatsToReschedule: '', rescheduleOldSeatNumbers: [], selectedStop: null});
  }

  selectDepartStop(stop, index) {
    let arriveStop = '';
    let schedules =  this.state.schedules;

    for(let i = 0; i < this.state.schedules[index].stops.length; i++) {
      if(this.state.arriveCity === this.state.schedules[index].stops[i].stop.city) {
        arriveStop = this.state.schedules[index].stops[i].id;
      }
    }

    
    let selectedRoutePrice = this.getCustomPriceIfAvailable(this.state.schedules[index],stop.id, arriveStop);

    selectedRoutePrice = selectedRoutePrice ? selectedRoutePrice : this.state.schedules[index].price;

    // Points-paid tickets reschedule seatless (seat add-on path is disabled on this legacy money flow —
    // ISSUE-20 scope guard); assign a seat afterward via Manage Seats.
    const rescheduleActiveRes = this.state.selectedLeg ? this.getActiveReservations(this.state.selectedLeg.reservations) : [];
    const isPointsReschedule = !!(rescheduleActiveRes[0] && rescheduleActiveRes[0].vouchers);
    const originalHadSeats = !isPointsReschedule && this.state.selectedLeg
      ? this.getSeatNumbersForLeg(this.state.selectedLeg).length > 0
      : false;
    this.setState({
      departCity: stop.stop.city,
      departStop: stop.id,
      slot: stop.time,
      arriveStop: arriveStop,
      selectedBus: index,
      schedules,
      selectedRoutePrice,
      rescheduleSelectedSeats: [],
      showRescheduleSeatSelection: false,
      skipSeatSelection: false,
      rescheduleTakenSeats: [],
      rescheduleTempTakenSeats: [],
      reschedulePricingTiers: [],
      reschedulePendingSeats: [],
      reschedulePendingReleaseSeats: [],
    }, () => {
      if (originalHadSeats) {
        this.openSeatSelection();
      } else {
        this.setState({ skipSeatSelection: true });
      }
    });
    scheduleService.releaseAllHolds(getSessionId())
      .catch(function(err) { console.error('[releaseAllHolds busChange]', err); });
  }

  selectArriveStop(stop, index) {
    if(index === this.state.selectedBus) {
      this.setState({arriveStop: stop});
    }
  }

  getRescheduleBusType() {
    if (this.state.selectedBus !== null && this.state.schedules && this.state.schedules[this.state.selectedBus]) {
      return this.state.schedules[this.state.selectedBus].bus_type?.type || 'Standard';
    }
    return 'Standard';
  }

  fetchRescheduleSeatInfo() {
    if (this.state.selectedBus === null || !this.state.schedules) {
      return Promise.resolve();
    }
    const bus = this.state.schedules[this.state.selectedBus];
    const scheduleBus = bus.schedule_bus;
    const slot = moment(this.state.departDate).format('YYYY-MM-DD');
    const sessionId = getSessionId();
    this.setState({ rescheduleSeatInfoLoading: true });

    return scheduleService.getSeatInfo(scheduleBus, slot, sessionId, this.state.departCity, this.state.arriveCity)
      .then((data) => {
        this.setState({
          rescheduleTakenSeats: data.takenSeats || [],
          rescheduleTempTakenSeats: data.temporaryTakenSeats || [],
          reschedulePricingTiers: (data && data.pricing && data.pricing.tiers) || [],
          rescheduleSeatInfoLoading: false,
        });
      })
      .catch((err) => {
        console.error('[getSeatInfo reschedule]', err);
        this.setState({ rescheduleSeatInfoLoading: false });
      });
  }

  handleRefreshRescheduleSeats() {
    this.fetchRescheduleSeatInfo().then(() => {
      const allTaken = (this.state.rescheduleTakenSeats || []).concat(this.state.rescheduleTempTakenSeats || []);
      const kept = this.state.rescheduleSelectedSeats.filter(function(s) { return allTaken.indexOf(s) === -1; });
      const needed = parseInt(this.state.seatsToReschedule, 10) || 0;
      const update = { rescheduleSelectedSeats: kept };
      // A selected seat got taken/blocked meanwhile: reopen the picker so the admin can pick a replacement
      if (!this.state.skipSeatSelection && kept.length < this.state.rescheduleSelectedSeats.length && kept.length < needed) {
        update.showRescheduleSeatSelection = true;
      }
      this.setState(update);
    });
  }

  handleRescheduleSeatSelect(seatId) {
    const selectedSeats = this.state.rescheduleSelectedSeats;
    const maxSeats = parseInt(this.state.seatsToReschedule, 10) || 0;

    const bus = this.state.schedules[this.state.selectedBus];
    const scheduleBus = bus.schedule_bus;
    const slot = moment(this.state.departDate).format('YYYY-MM-DD');
    const sessionId = getSessionId();

    if (selectedSeats.indexOf(seatId) !== -1) {
      this.setState({
        rescheduleSelectedSeats: selectedSeats.filter(function(s) { return s !== seatId; })
      });
      scheduleService.releaseSeat(scheduleBus, slot, seatId, sessionId)
        .catch(function(err) { console.error('[releaseSeat reschedule]', err); });
    } else {
      if (selectedSeats.length >= maxSeats) {
        return;
      }
      this.setState({
        rescheduleSelectedSeats: selectedSeats.concat([seatId])
      });
      scheduleService.holdSeat(scheduleBus, slot, seatId, sessionId)
        .catch((err) => {
          if (err && err.status === 409) {
            this.setState({
              rescheduleSelectedSeats: this.state.rescheduleSelectedSeats.filter(function(s) { return s !== seatId; })
            });
            this.fetchRescheduleSeatInfo();
          }
          console.error('[holdSeat reschedule]', err);
        });
    }
  }

  openSeatSelection() {
    this.setState({
      showRescheduleSeatSelection: true,
      skipSeatSelection: false,
      rescheduleSelectedSeats: [],
      reschedulePendingSeats: [],
      reschedulePendingReleaseSeats: [],
    }, () => {
      this.fetchRescheduleSeatInfo();
    });
  }

  skipSeatSelectionStep() {
    this.setState({
      skipSeatSelection: true,
      showRescheduleSeatSelection: false,
      rescheduleSelectedSeats: [],
    });
    scheduleService.releaseAllHolds(getSessionId())
      .catch(function(err) { console.error('[releaseAllHolds skip]', err); });
  }

  closeSeatSelection() {
    this.setState({
      showRescheduleSeatSelection: false,
      rescheduleSelectedSeats: [],
      skipSeatSelection: true,
      reschedulePendingSeats: [],
      reschedulePendingReleaseSeats: [],
    });
    scheduleService.releaseAllHolds(getSessionId())
      .catch(function(err) { console.error('[releaseAllHolds closeSeat]', err); });
  }

  editSeatSelection() {
    this.setState({
      showRescheduleSeatSelection: true,
      skipSeatSelection: false,
      reschedulePendingSeats: [],
      reschedulePendingReleaseSeats: [],
    }, () => {
      this.fetchRescheduleSeatInfo();
    });
  }

  getRescheduleSeatTotal() {
    const selectedSeats = this.state.rescheduleSelectedSeats;
    if (!selectedSeats.length || this.state.selectedBus === null) {
      return 0;
    }
    const busType = this.getRescheduleBusType();
    const basePrice = this.state.selectedRoutePrice || 0;
    const tiers = this.state.reschedulePricingTiers;
    let total = 0;
    for (let i = 0; i < selectedSeats.length; i++) {
      total += getSeatPrice(selectedSeats[i], basePrice, busType, tiers);
    }
    return total;
  }

  getNewEffectiveTotal() {
    const seats = parseInt(this.state.seatsToReschedule, 10) || 0;
    if (this.state.rescheduleSelectedSeats && this.state.rescheduleSelectedSeats.length > 0) {
      return this.getRescheduleSeatTotal();
    }
    return (this.state.selectedRoutePrice || 0) * seats;
  }

  getPricePaidTotal() {
    const seats = parseInt(this.state.seatsToReschedule, 10) || 0;
    return this.getPricePaid() * seats;
  }

  renderRescheduleSeatSection() {
    const busType = this.getRescheduleBusType();
    const basePrice = this.state.selectedRoutePrice || 0;
    const busLayout = getBusLayout(busType);
    const pricingTiers = this.state.reschedulePricingTiers;
    const maxSeats = parseInt(this.state.seatsToReschedule, 10) || 0;
    const selectedSeats = this.state.rescheduleSelectedSeats;
    const takenSeats = this.state.rescheduleTakenSeats || [];
    const tempTakenSeats = this.state.rescheduleTempTakenSeats || [];
    const allSeatIds = getAllSeatIds(busType);
    const unavailable = takenSeats.concat(tempTakenSeats);
    const availableCount = allSeatIds.filter(function(id) { return unavailable.indexOf(id) === -1; }).length;
    const showCapacityWarning = maxSeats > 0 && maxSeats > availableCount;
    const isRefreshing = this.state.rescheduleSeatInfoLoading;
    const bus = (this.state.selectedBus !== null && this.state.schedules) ? this.state.schedules[this.state.selectedBus] : null;
    const busLetter = bus ? bus.letter : '';
    const departTime = this.state.slot ? moment(this.state.slot, 'HH:mm:ss').format('h:mm a') : '';
    const departStopObj = bus && this.state.departStop ? bus.stops.find(s => s.id === this.state.departStop) : null;
    const departAddress = departStopObj ? departStopObj.stop.address : '';
    const pendingSeats = this.state.reschedulePendingSeats || [];
    const pendingReleaseSeats = this.state.reschedulePendingReleaseSeats || [];

    return (
      <div className="admin-seat-selection">
        <div className="seat-section-header">
          <span className="header-title">Select Seats &mdash; Bus {busLetter} ({busType}){departTime ? ', departing ' + departTime : ''}</span>
          <div className="header-right">
            <span className="selected-count">{selectedSeats.length} / {maxSeats} seat{maxSeats !== 1 ? 's' : ''} selected</span>
            <button
              className={'btn-refresh' + (isRefreshing ? ' refreshing' : '')}
              onClick={this.handleRefreshRescheduleSeats}
              title="Refresh seat availability"
              disabled={isRefreshing}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" />
              </svg>
            </button>
          </div>
        </div>
        {departAddress && (
          <div style={{ fontSize: '12px', color: '#fff', padding: '4px 12px 0', background: '#333', marginTop: '-1px' }}>
            {departTime} from {departAddress}
          </div>
        )}
        <div className="seat-section-body">
          <div className="instruction-text">Click on a seat to select or deselect it</div>
          {!this.state.skipSeatSelection && selectedSeats.length < maxSeats && (
            <div style={{ color: '#e67e22', fontSize: '13px', margin: '4px 0 8px' }}>
              Select {maxSeats - selectedSeats.length} more seat{maxSeats - selectedSeats.length !== 1 ? 's' : ''} ({selectedSeats.length} of {maxSeats} selected)
            </div>
          )}
          {!this.state.skipSeatSelection && selectedSeats.length === maxSeats && maxSeats > 0 && (
            <div style={{ color: '#27ae60', fontSize: '13px', margin: '4px 0 8px' }}>
              All {maxSeats} seat{maxSeats !== 1 ? 's' : ''} selected
            </div>
          )}
          <div className="seat-map-container" style={{ position: 'relative' }}>
            {isRefreshing && (
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(255,255,255,0.6)', zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'not-allowed' }}>
                <span style={{ color: '#888', fontSize: '14px', fontWeight: 'bold' }}>Loading seat availability...</span>
              </div>
            )}
            <SeatMap
              busLayout={busLayout}
              selectedSeats={selectedSeats}
              takenSeats={takenSeats}
              temporaryTakenSeats={tempTakenSeats}
              pendingSeats={pendingSeats}
              pendingReleaseSeats={pendingReleaseSeats}
              basePrice={basePrice}
              pricingTiers={pricingTiers}
              onSeatSelect={this.handleRescheduleSeatSelect}
              maxSeats={maxSeats}
              maxSelectableRow={busLayout.maxSelectableRow}
              adminMode={true}
            />
            <div>
              <SeatLegend
                showPricingInfo={true}
                basePrice={basePrice}
                pricingTiers={pricingTiers}
                showFCFS={true}
                adminMode={true}
              />
              {selectedSeats.length > 0 && (() => {
                let seatsSubtotal = 0;
                const rows = selectedSeats.map(function(seatId) {
                  const total = getSeatPrice(seatId, basePrice, busType, pricingTiers);
                  const addOn = total - basePrice;
                  seatsSubtotal += total;
                  return { seatId, base: basePrice, addOn, total };
                });
                return (
                  <div className="selected-seats-summary">
                    <div className="summary-title">Selected Seats</div>
                    <div className="selected-seats-list">
                      {rows.map(function(r) {
                        return (
                          <div key={r.seatId} className="selected-seat-item-breakdown">
                            <div className="seat-breakdown-header">
                              <span className="seat-id">{r.seatId}</span>
                              <span className="seat-price">{numeral(r.total).format('$0,0.00')}</span>
                            </div>
                            <div className="seat-breakdown-row">
                              <span>Base</span>
                              <span>{numeral(r.base).format('$0,0.00')}</span>
                            </div>
                            <div className="seat-breakdown-row">
                              <span>Add-on</span>
                              <span>+{numeral(r.addOn).format('$0,0.00')}</span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div className="selected-seats-total">
                      <span>Total</span>
                      <span>{numeral(seatsSubtotal).format('$0,0.00')}</span>
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>
        </div>
        {showCapacityWarning && (
          <div className="seat-capacity-warning">
            Only {availableCount} seat{availableCount !== 1 ? 's' : ''} available on the bus. {maxSeats - availableCount} seat(s) will be unassigned.
          </div>
        )}
        <div style={{ margin: '12px 0 0', display: 'flex', alignItems: 'center' }}>
          <input
            type="checkbox"
            id="reschedule-skip-seat-checkbox"
            checked={!!this.state.skipSeatSelection}
            onChange={this.handleRescheduleSkipToggle.bind(this)}
            style={{ marginRight: '8px' }}
          />
          <label htmlFor="reschedule-skip-seat-checkbox" style={{ margin: 0, fontWeight: 'normal', cursor: 'pointer' }}>
            Skip seat assignment (proceed without picking a seat)
          </label>
        </div>
      </div>
    );
  }

  handleRescheduleSkipToggle(e) {
    const checked = e.target.checked;
    if (checked) {
      this.setState({
        skipSeatSelection: true,
        rescheduleSelectedSeats: [],
      });
      scheduleService.releaseAllHolds(getSessionId())
        .catch(function(err) { console.error('[releaseAllHolds skipToggle]', err); });
    } else {
      this.setState({ skipSeatSelection: false });
    }
  }

  getPaid() {
    if(this.state.selectedLeg) {
      let val = this.getActiveReservations(this.state.selectedLeg.reservations)[0].order_item.amount*this.state.seatsToReschedule;
      if(this.state.selectedLeg.coupon) {
        if(this.state.selectedLeg.coupon.type === '$') {
          return val - this.state.selectedLeg.coupon.amount;
        }
        else {
          return val - ((val*this.state.selectedLeg.coupon.amount)/100);
        }
      }
      return val;
    }
    return 0;
  }

  getPricePaid() {
    if(this.state.selectedLeg) {
      const moving = this.getRescheduleMovingReservations();
      if(!moving.length) {
        return 0;
      }
      let val = 0;
      for(let i = 0; i < moving.length; i++) {
        const res = moving[i];
        if(res.vouchers) {
          val += res.order_item.amount;
        }
        else {
          val += (res.credit || 0) + (res.paid || 0);
        }
      }
      return val/moving.length;
    }
    return 0;
  }

  getPricePaidBreakup() {
    let breakup = {
      paid: 0,
      credits: 0,
      points: 0
    };
    let response = '';
    if(this.state.selectedLeg) {
      const moving = this.getRescheduleMovingReservations();
      for(let i = 0; i < moving.length; i++) {
        const res = moving[i];
        if(res.vouchers) {
          breakup.paid += res.paid || 0;
          breakup.credits += res.credit || 0;
          breakup.points += res.vouchers;
        } else {
          breakup.paid += res.paid || 0;
          breakup.credits += res.credit || 0;
        }
      }
      const parts = [];
      if(breakup.paid) {
        parts.push(`$${breakup.paid} Cash`);
      }
      if(breakup.credits) {
        parts.push(`$${breakup.credits} Tripperbus Credits`);
      }
      if(breakup.points) {
        parts.push(`${breakup.points} Points`);
      }
      response = parts.join(' + ');
    }
    response = response || '0';
    return {object: breakup, text: response};
  }

  getRequiredPoints() {
    const res = {
      points: 0,
      pointsAmount: 0,
    };
    if(this.state.selectedBus !== null && this.state.selectedLeg && this.getActiveReservations(this.state.selectedLeg.reservations)[0].vouchers && this.state.schedules[this.state.selectedBus].bus_type.type === 'Elite' && this.state.selectedLeg.schedule_bus.bus_type.type !== 'Elite') {
      const movingRows = this.getRescheduleMovingReservations();
      for(let i = 0; i < movingRows.length; i++) {
        if(movingRows[i].vouchers) {
          res.pointsAmount += Math.max(0, this.state.selectedRoutePrice - this.state.selectedLeg.legPrice);
          res.points += 6;
        }
        else if((movingRows[i].paid || movingRows[i].credit) && this.state.schedules[this.state.selectedBus].bus_type.type === 'Elite') {
          res.pointsAmount += Math.max(0, this.state.selectedRoutePrice - this.state.selectedLeg.legPrice);
          res.points += 12;
        }
        else if((movingRows[i].paid || movingRows[i].credit) && this.state.schedules[this.state.selectedBus].bus_type.type !== 'Elite') {
          res.pointsAmount += Math.max(0, this.state.selectedRoutePrice - this.state.selectedLeg.legPrice);
          res.points += 6;
        }
      }
    }
    // Same-type points reschedule is a flat points transfer (points are fare-blind: N points = any base
    // fare of that bus type) — cover the dollar fare difference so no card charge is requested.
    // Backend already handles this payload correctly (points reconsumed, seat cash banks).
    if(this.state.selectedBus !== null && this.state.selectedLeg && this.getActiveReservations(this.state.selectedLeg.reservations)[0].vouchers && this.state.schedules[this.state.selectedBus].bus_type.type === this.state.selectedLeg.schedule_bus.bus_type.type) {
      const sameTypeRows = this.getRescheduleMovingReservations();
      for(let i = 0; i < sameTypeRows.length; i++) {
        if(sameTypeRows[i] && sameTypeRows[i].vouchers) {
          res.pointsAmount += Math.max(0, this.state.selectedRoutePrice - this.state.selectedLeg.legPrice);
        }
      }
    }
    return res;
  }

  getCredits() {
    if (this.getActiveReservations(this.state.selectedLeg.reservations)[0].vouchers) {
      return 0;
    }
    return (this.getAmount() > this.state.selectedLeg.user.credits ? this.state.selectedLeg.user.credits : this.getAmount());
  }

  getAmount() {
    if(this.state.selectedBus !== null && this.state.selectedLeg) {
      if(this.state.customAmount) {
        return parseInt(this.state.customAmount, 10);
      }
      else if(this.getActiveReservations(this.state.selectedLeg.reservations)[0].vouchers && this.getRequiredPoints().points > this.state.selectedLeg.user.points) {
        return this.getNewEffectiveTotal();
      }
      // TRIP-180: compare seat-inclusive totals (base fare + seat add-on), same as MainReservations.
      // Comparing the bare route price hid any upcharge that came from the seat add-on and the
      // reschedule went through with the difference never collected.
      else if(this.getNewEffectiveTotal() >= this.getPricePaidTotal()) {
        return this.getNewEffectiveTotal() - this.getPricePaidTotal();
      }
    }
    return 0;
  }

  sortItems(items) {
    if(!this.state.order || !items) {
      return items;
    }
    else if(this.state.order === 'firstName' || this.state.order === 'email'){
      return _.orderBy(items, item => {
        return item.user[this.state.order].toLowerCase();
      });
    }
    else if(this.state.order === 'reservationNumber'){
      return _.orderBy(items, item => {
        return item[this.state.order];
      });
    }
    else if(this.state.order === 'slot'){
      return _.orderBy(items, item => {
        return new Date(item[this.state.order]);
      });
    }
    else if(this.state.order === 'created_at'){
      return _.orderBy(items, item => {
        return new Date(item[this.state.order]);
      });
    }
    else if(this.state.order === 'seats'){
      return _.orderBy(items, item => {
        return item.active;
      });
    }
  }

  getSeatsWithPoints(seats) {
    let count = 0;
    for(let i = 0; i < this.state.seatsToReschedule; i++) {
      if(seats[i].vouchers) {
        count++;
      }
    }
    return count;
  }

  waiveDifference() {
    this.setState({waiveDifference: !this.state.waiveDifference});
  }

  handleRowChange(e) {
    const obj = { ...this.state.rowObject };
    obj[e.target.name] = e.target.value;
    this.setState({rowObject: obj});
  }

  getTotalSelected() {
    let count = 2;
    for(let key in this.state.fields) {
      if(this.state.fields[key]) {
        count++;
      }
    }
    return count;
  }

  getVouchersMessage() {
    const breakup = this.getPricePaidBreakup().object;
    if(!breakup.paid && !breakup.credits) {
      return `Customer paid the total with ${breakup.points} points, new reservation is worth ${this.state.seatsToReschedule*12} points`;
    }
    if(breakup.paid || breakup.credits) {
      return `Customer paid the total with ${this.getPricePaidBreakup().text}, new reservation is worth ${this.state.seatsToReschedule*(this.state.schedules[this.state.selectedBus].bus_type.type === 'Elite' ? 12 : 6)} points`;
    }
    return '';
  }

  showEditPrice(schedule_bus, index){
    let departStops = schedule_bus.stops.filter((stop)=> stop.type === "PU" && !stop.deleted).map((stop)=>({...stop, stop: stop.stop.id}));
    let destinationStops = schedule_bus.stops.filter((stop)=> stop.type === "DO" && !stop.deleted).map((stop)=>({...stop, stop: stop.stop.id}));
    let prices = schedule_bus.prices;
    let stopCombination = constructPricesMap(departStops, destinationStops, prices, this.props.stops);
    this.setState({showModal:true, currentSelectedBus: stopCombination, currentSelectedBusIndex: index});
  }

  getCustomPriceIfAvailable(bus, scheduledDepartStopId, scheduledArriveStopId){
    if(bus.prices && bus.prices.length > 0){
        for(let price of bus.prices){
            if(price.from_schedule_bus_stop_id === scheduledDepartStopId && price.to_schedule_bus_stop_id === scheduledArriveStopId){
                return price.price;
            }
        }
    }
    return null;

  }

  render() {
    const mainItems = this.props.mainItems || [];
    return (
      <div className="content">
        <Grid fluid>
          {mainItems && <Row>
            <Col md={12}>
              <div className="addition-fields-checks row">
                <Col md={6}>
                <div className="showHide">Show/Hide Fields</div>
                <div className="checks">
                  <label>
                    <input type="checkbox" name="created_at" onChange={this.toggleField.bind(this)} /> Date Made
                  </label>
                  <label>
                    <input type="checkbox" name="legPrice" onChange={this.toggleField.bind(this)} /> Leg Price
                  </label>
                  <label>
                    <input type="checkbox" name="paid" onChange={this.toggleField.bind(this)} /> Transaction Amount
                  </label>
                  <label>
                    <input type="checkbox" name="pointsUsed" onChange={this.toggleField.bind(this)} /> Points Used
                  </label>
                  <label>
                    <input type="checkbox" name="creditUsed" onChange={this.toggleField.bind(this)} /> Credits Used
                  </label>
                  <label>
                    <input type="checkbox" name="pointsEarned" onChange={this.toggleField.bind(this)} /> Points Earned
                  </label>
                  <label>
                    <input type="checkbox" name="paymentMethod" onChange={this.toggleField.bind(this)} /> Payment Method
                  </label>
                  <label>
                    <input type="checkbox" name="paymentGatewayId" onChange={this.toggleField.bind(this)} /> Authorize.net Link
                  </label>
                  <label>
                    <input type="checkbox" name="checked" onChange={this.toggleField.bind(this)} /> Checked In
                  </label>
                  <label>
                    <input type="checkbox" name="user_ip" onChange={this.toggleField.bind(this)} /> User IP
                  </label>
                  <label>
                    <input type="checkbox" name="made_by" onChange={this.toggleField.bind(this)} /> Made By
                  </label>
                  <label>
                    <input type="checkbox" name="account" onChange={this.toggleField.bind(this)} /> Under Account
                  </label>
                  <label>
                    <input type="checkbox" name="promo" onChange={this.toggleField.bind(this)} /> Promo Code
                  </label>
                  <label>
                    <input type="checkbox" name="action_records" onChange={this.toggleField.bind(this)} /> Action Records
                  </label>
                  <label>
                    <input type="checkbox" name="otherLeg" onChange={this.toggleField.bind(this)} /> Other leg
                  </label>
                </div>
                </Col>
                <Col md={6}>
                <div className="list-order">
                  <div className="showHide">Order Of Display</div>
                  <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        componentClass: "select",
                        bsClass: "form-control",
                        value: this.state.order,
                        name: 'order',
                        onChange: this.handleOrder.bind(this),
                        options: [
                          {label: 'Name', value: 'firstName'},
                          {label: 'Reservation Number', value: 'reservationNumber'},
                          {label: 'Email', value: 'email'},
                          {label: 'Travel Date', value: 'slot'},
                          {label: 'Date/Time Made', value: 'created_at'},
                          {label: 'Seats', value: 'seats'}
                        ]
                      }
                    ]}
                  />
                </div>
                </Col>
              </div>
              <Card
                title=""
                category={queryStringToJSON(this.props.location.search).column ? '   for a '+queryStringToJSON(this.props.location.search).column + ' containing '+ queryStringToJSON(this.props.location.search).value + ' found the following '+mainItems.length+' records' : ''}
                content={
                  <div>
                    <div className="reserve-wrapper infinite-height" id="infinite-scroller">
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <th style={{paddingLeft: '15px'}}>
                              <input type="checkbox" onChange={this.toggleSelectAll.bind(this)} />
                            </th>
                            {this.state.fields.user && <th>Name</th>}
                            {this.state.fields.email && <th>Email</th>}
                            {this.state.fields.phone && <th>Phone</th>}
                            <th>Date</th>
                            <th>Time</th>
                            <th>Stop City</th>
                            {this.state.fields.seats && <th>Seats</th>}
                            {this.state.fields.seats && <th>Seats booked</th>}
                            {this.state.fields.legPrice && <th>Leg Price</th>}
                            {this.state.fields.pointsUsed && <th>Points Used</th>}
                            {this.state.fields.creditUsed && <th>Credits Used</th>}
                            {this.state.fields.paid && <th>Transaction Amount</th>}
                            {this.state.fields.pointsEarned && <th>Points Earned (after travel)</th>}
                            {this.state.fields.paymentMethod && <th>Payment Method</th>}
                            {this.state.fields.paymentGatewayId && <th>Authorize.net Link</th>}
                            {this.state.fields.checked && <th>Checked In</th>}
                            {this.state.fields.user_ip && <th>User IP</th>}
                            {this.state.fields.created_at && <th>Date Made</th>}
                            {this.state.fields.made_by && <th>Made By</th>}
                            {this.state.fields.reservationNumber && <th>Reservation #</th>}
                            {this.state.fields.account && <th>Under Account</th>}
                            {this.state.fields.promo && <th>Promo Code</th>}
                            {this.state.fields.action_records && <th>Action Records</th>}
                            {this.state.fields.otherLeg && <th>Other Leg</th>}
                            <th>Actions</th>
                          </tr>
                        </tbody>
                        <tbody id="infinite-scroller-body">
                          {this.sortItems(mainItems).map((res, num) => {
                            return (
                              res.status !== 'deleted' && res.user && <tr key={num}>
                                <td><input type="checkbox" onChange={this.toggleSelect.bind(this, res.id)} checked={this.checkSelected(res.id)} /></td>
                                {this.state.fields.user && <td><NavLink to={"/dashboard/search-reservations?column=firstName&value="+res.user.firstName+"&searchIn=reservations"}>{res.firstName + " " + res.lastName}</NavLink></td>}
                                {this.state.fields.email && <td><NavLink to={"/dashboard/search-reservations?column=email&value="+res.user.email+"&searchIn=reservations"}>{res.user.email}</NavLink></td>}
                                {this.state.fields.phone && <td><NavLink to={"/dashboard/search-reservations?column=phone&value="+res.user.phone+"&searchIn=reservations"}>{res.user.phone}</NavLink></td>}
                                <td>{moment(res.slot, 'YYYY-MM-DD').format('MM-DD-YY')}</td>
                                <td>{moment(res.depart_stop.time, 'HH:mm:ss').format('hh:mm A')}</td>
                                <td>{res.depart_stop.stop.city}</td>
                                {this.state.fields.seats && <td>{res.active}</td>}
                                {this.state.fields.seats && <td>{(function() {
                                  var reservations = res.reservations || [];
                                  var list = reservations
                                    .filter(function(r) { return r.status === 'active'; })
                                    .map(function(r) { return r.seat_number != null ? r.seat_number : (r.order_item && r.order_item.seat_number); })
                                    .filter(Boolean);
                                  return list.length ? list.join(', ') : '';
                                })()}</td>}
                                {this.state.fields.legPrice && <td>{numeral(res.legPrice).format('$0,0.00')}</td>}
                                {this.state.fields.pointsUsed && <td>{res.pointsUsed}</td>}
                                {this.state.fields.creditUsed && <td>{res.creditUsed}</td>}
                                {this.state.fields.paid && <td>{numeral(res.transactionAmount).format('$0,0.00')}</td>}
                                {this.state.fields.pointsEarned && <td>{res.pointsEarned}</td>}
                                {this.state.fields.paymentMethod && <td>{(res.reservations && res.reservations[0] && res.reservations[0].order_item && res.reservations[0].order_item.order ? res.reservations[0].order_item.order.paymentMethod : '')}</td>}
                                {this.state.fields.paymentGatewayId && <td>{res.paymentGatewayId}</td>}
                                {this.state.fields.checked && <td>{res.checked ? 'Yes' : 'No'}</td>}
                                {this.state.fields.user_ip && <td>{res.user_ip}</td>}
                                {this.state.fields.created_at && <td>{moment(res.created_at).format('MM/DD/YY hh:mm a')}</td>}
                                {this.state.fields.made_by && <td>{res.made_by ? (res.made_by.firstName + " " + res.made_by.lastName) : ''}</td>}
                                {this.state.fields.reservationNumber && <td>{config.formatReservationNumber(res.reservationNumber)}{res.schedule_bus.bus_type.type === 'Elite' && <div className="elite-res">Elite</div>}</td>}
                                {this.state.fields.account && this.state.editingId !== res.id && <td><NavLink to={"/dashboard/customers/"+res.user.id}>{(res.firstName || res.user.firstName) + " " + (res.lastName || res.user.lastName)}</NavLink></td>}
                                {this.state.editingId === res.id && this.state.fields.account && <td><input value={this.state.rowObject.firstName} name="firstName" onChange={this.handleRowChange.bind(this)} /><input value={this.state.rowObject.lastName} name="lastName" onChange={this.handleRowChange.bind(this)} /></td>}
                                {this.state.fields.promo && <td>{res.coupon ? <NavLink to={"/dashboard/coupons/"+res.coupon.id}>{res.coupon.code}</NavLink> : ''}</td>}
                                {this.state.fields.action_records && <td>
                                  {this.getRecordsSummary(res).map((item, k) => {
                                    return (
                                      <div key={k}>
                                        <a href="javascript:void(0)" onClick={this.showActionDetails.bind(this, res.action_records[k])}>{item}</a>
                                      </div>
                                    )
                                  })}
                                </td>}
                                {this.state.fields.otherLeg && <td>{res.otherLeg && config.formatReservationNumber(res.otherLeg)}</td>}
                                <td>
                                  <div className="table-actions res-actions">
                                    {this.state.editingId === res.id && <a href="javascript:void(0)" onClick={this.saveRow.bind(this)}>Save</a>}
                                    {this.state.editingId !== res.id && <a href="javascript:void(0)" onClick={this.editRow.bind(this, res)}>Edit</a>}
                                    <a href="javascript:void(0)" className={(res.reservation_remarks ? 'highlight-note' : '')} onClick={this.showNotes.bind(this, res)}>Notes</a>
                                    {res.active > 0 && <a href="javascript:void(0)" onClick={this.reschedule.bind(this, res)}>Reschedule</a>}
                                    {res.active > 0 && <a href="javascript:void(0)" onClick={this.openManageSeatsModal.bind(this, res)}>Manage Seats</a>}
                                    {res.active > 0 && <a className="red" href="javascript:void(0)" onClick={this.cancel.bind(this, res)}>Cancel</a>}
                                  </div>
                                </td>
                              </tr>
                            )
                          })}
                          {this.props.loading && <tr key={0}><td colSpan={this.getTotalSelected()}><Loader /></td></tr>}
                        </tbody>
                      </table>
                      {(!this.props.loading && (!mainItems || mainItems.length === 0)) && <div className="text-center no-result-found">No results found</div>}
                    </div>
                    <div>
                      <Row className="res-actions-container">
                        <Col md={6}>
                          <FormInputs
                            ncols={["col-md-12"]}
                            proprieties={[
                              {
                                label: "Do the following to all checked",
                                componentClass: "select",
                                bsClass: "form-control",
                                value: this.state.action,
                                name: 'action',
                                onChange: this.handleChange,
                                options: [
                                  {label: 'Delete', value: 'delete'},
                                  {label: 'Note', value: 'note'},
                                  {label: 'Re-email', value: 'email'},
                                  {label: 'Custom email only', value: 'customEmail'},
                                  {label: 'Text only', value: 'text'},
                                  {label: 'Custom email and text', value: 'customEmailAndText'},
                                  {label: 'Check in', value: 'checked'},
                                  {label: 'Complimentary seats as reserved', value: 'complimentaryAll'},
                                  {label: 'Complimentary one seat', value: 'complimentaryOne'},
                                  {label: 'Complimentary partial credit', value: 'complimentaryPartial'}
                                ],
                              }
                            ]}
                          />
                          {this.state.action === 'complimentaryPartial' && <FormInputs
                            ncols={["col-md-12"]}
                            proprieties={[
                              {
                                label: "How much credit you would like to add?",
                                bsClass: "form-control",
                                value: this.state.credit,
                                name: 'credit',
                                onChange: this.handleChange,
                                type: 'number',
                                placeholder: 'Credit Amount'
                              }
                            ]}
                          />}
                          {(this.state.action === 'complimentaryOne') && <FormInputs
                            ncols={["col-md-12"]}
                            proprieties={[
                              {
                                label: "Enter custom amount",
                                bsClass: "form-control",
                                value: this.state.credit,
                                name: 'credit',
                                onChange: this.handleChange,
                                type: 'number',
                                placeholder: 'Amount'
                              }
                            ]}
                          />}
                          <FormInputs
                            ncols={["col-md-12"]}
                            proprieties={[
                              {
                                label: "Email subject entry box:",
                                bsClass: "form-control",
                                value: this.state.subject,
                                name: 'subject',
                                onChange: this.handleChange,
                                type: 'text',
                                placeholder: 'Subject',
                                disabled: (this.state.action === 'note' || this.state.action === 'delete' || this.state.action === 'email' || this.state.action === 'text' || this.state.action === 'checked' || this.state.action === 'complimentaryAll' || this.state.action === 'complimentaryOne' || this.state.action === 'complimentaryPartial')
                              }
                            ]}
                          />
                          <FormInputs
                            ncols={["col-md-12"]}
                            proprieties={[
                              {
                                label: "Notes/Email body box:",
                                bsClass: "form-control",
                                componentClass: 'textarea',
                                value: this.state.body,
                                name: 'body',
                                onChange: this.handleChange,
                                placeholder: 'Body',
                                disabled: (this.state.action === 'delete' || this.state.action === 'email' || this.state.action === 'text' || this.state.action === 'checked')
                              }
                            ]}
                          />
                          <FormInputs
                            ncols={["col-md-12"]}
                            proprieties={[
                              {
                                label: "Text message box:",
                                bsClass: "form-control",
                                value: this.state.text,
                                componentClass: 'textarea',
                                name: 'text',
                                onChange: this.handleChange,
                                type: 'text',
                                placeholder: 'Text',
                                disabled: (this.state.action === 'note' || this.state.action === 'delete' || this.state.action === 'email' || this.state.action === 'customEmail' || this.state.action === 'checked' || this.state.action === 'complimentaryAll' || this.state.action === 'complimentaryOne' || this.state.action === 'complimentaryPartial')
                              }
                            ]}
                          />
                          <Button bsStyle="info" disabled={this.props.loading || this.state.loading || this.state.selected.length === 0} onClick={this.proceed.bind(this)} fill type="button">
                            OK
                          </Button>
                          {(this.state.loading || this.props.loading) && this.state.submitted && 
                            <img alt="" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                          }
                        </Col>
                        <Col md={6} className="action-rules">
                          <h4>Action Rules <span>(For the commands on the left)</span></h4>
                          <div className="rules">
                            <b>1) EMAIL SUBJECT ENTRY BOX:</b><br/>
                            Default subject lines (in emails only) are as follows:
                            <br/>Custom Emails: "Re: Reservation # XYZ123456"
                            <br/>Re-emailed Emails: "Re-Emailing Reservation Information"
                            <br/>Placed on hold: "Reservation Placed On Hold"
                            <br/>Complimentary Tickets: "Complimentary Ticket(s) Toward Future Travel"
                            <br/>By default you do not need to enter any subject and the default subject will be automatically filled out as above:
                            <br/>However, if you do want a custom subject line instead of the default ones listed above, type it in the subject box provided. <em>(Note: 60 chars. max)</em>
                            <br/><br/>

                            <b>2) NOTES/EMAILS BODY BOX, ALSO "REASON" BOX:</b>
                            <br/>If "Noting" or "Custom Emailing", you have to enter the body of the text you want to email or note in that box.
                            <br/>If "Placing On Hold", you may enter (optional) the reason you are doing the hold (if any) into that box.
                            Bear in mind that the customer sees it all in their email and that the words "Reason for this action:" is also in there prefilled, followed by the resaon you entered <br/>
                            If choosing "Complimentary Tickets", whether one or multiple, you have to enter the reason you are issuing the complimentary tickets into the following box, and in the email they will see "Reason for this action: whatever reason"<br/>
                            (P.S., emails are always automatically preceded with "Dear First Last Name",<br/>
                            and after the email body they are always automatically signed with your default email footers, so there's no need to finish off with Sincerely etc.)
                            <br/><br/>

                            <b>3) TEXT MESSAGE BOX:</b>
                            Only text messages belong in this box.<br/>
                            (Note that the maximum characters for a text message is 160, and you will see a count of characters you have avaliable as you type<br/><br/>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                }
              />
            </Col>
          </Row>}
          {this.state.openNotes && <Notes
            open = {this.state.openNotes}
            onCloseModal = {this.closeNotes.bind(this)}
            data = {this.state.notesData}
          />}
          <Modal open={this.state.openCancel} onClose={this.closeCancel.bind(this)} center classNames={{ modal: 'cancel-seats-modal-root' }}>
            {this.state.openCancel && <div className="cancelSeatsModal cancel-modal-body">
              {this.state.selectedLeg && <p style={{margin: '0 0 10px', color: '#666', fontSize: '0.9em', flexShrink: 0}}>Reservation: <strong>{config.formatReservationNumber(this.state.selectedLeg.reservationNumber)}</strong></p>}
              {(() => {
                const userSeats = this.state.selectedLeg ? this.getSeatNumbersForLeg(this.state.selectedLeg) : [];
                const hasSeatNumbers = userSeats.length > 0;
                const busLayout = this.state.cancelBusLayout;

                if (hasSeatNumbers && this.state.cancelSeatInfoLoading) {
                  return <p>Loading seat layout...</p>;
                }

                if (hasSeatNumbers && busLayout && !this.state.showCancelSeatGrid) {
                  // "Single seat" must mean one TICKET total — unassigned tickets count too,
                  // otherwise partial cancellation is hidden for 1-seated + N-unassigned bookings
                  const cancelUnassignedTickets = this.state.selectedLeg ? this.getUnassignedCountForLeg(this.state.selectedLeg) : 0;
                  const singleSeat = userSeats.length === 1 && cancelUnassignedTickets === 0;
                  return (
                    <div className="cancel-step">
                      <h4 className="cancel-modal-title">Cancel reservation</h4>
                      {!singleSeat && <Fragment>
                        <p className="cancel-modal-subtitle">How many seats would you like to cancel?</p>
                        <div className="cancel-count-field">
                          <FormInputs
                            ncols={["col-md-12"]}
                            proprieties={[
                              {
                                componentClass: "select",
                                bsClass: "form-control",
                                value: this.state.cancelSeatCount,
                                name: 'cancelSeatCount',
                                onChange: this.handleSeatsChange.bind(this),
                                options: this.getSeatsOptions()
                              }
                            ]}
                          />
                        </div>
                      </Fragment>}
                      {singleSeat && <p className="cancel-modal-subtitle">This reservation has 1 seat ({userSeats[0]}).</p>}
                      <div className="cancel-modal-actions">
                        <Button bsStyle="default" type="button" onClick={this.closeCancel.bind(this)}>
                          Close
                        </Button>
                        {!singleSeat && <Button bsStyle="info" disabled={!this.state.cancelSeatCount} fill type="button" onClick={this.proceedToCancelSeatGrid.bind(this)}>
                          Next: Select Seats
                        </Button>}
                        <Button bsStyle="danger" disabled={this.state.loading} fill type="button" onClick={() => {
                          confirmAlert({
                            title: 'Cancel Entire Reservation',
                            message: 'Are you sure you want to cancel all seats in this reservation?',
                            buttons: [
                              { label: 'Yes, Cancel All', onClick: () => this.cancelEntireReservation() },
                              { label: 'No', onClick: () => '' }
                            ]
                          });
                        }}>
                          {this.state.loading ? 'Cancelling…' : 'Cancel Entire Reservation'}
                        </Button>
                      </div>
                    </div>
                  );
                }

                if (hasSeatNumbers && busLayout && this.state.showCancelSeatGrid) {
                  const allSeatIds = this.getAllSeatIdsFromLayout(busLayout);
                  const cancelModeTakenSeats = allSeatIds.filter((id) => userSeats.indexOf(id) === -1);
                  const cancelUnassignedTotal = this.state.selectedLeg ? this.getUnassignedCountForLeg(this.state.selectedLeg) : 0;
                  const cancelUnassignedCount = this.state.cancelUnassignedCount || 0;
                  const cancelTotalSelected = this.state.cancelSeatNumbers.length + cancelUnassignedCount;
                  const cancelTotalSeats = userSeats.length + cancelUnassignedTotal;
                  return (
                    <div className="cancel-step">
                      <h4 className="cancel-modal-title">Select seats to cancel</h4>
                      <p className="cancel-modal-subtitle">
                        <strong>{cancelTotalSelected}</strong> of <strong>{cancelTotalSeats}</strong> selected. Click a seat in this reservation to toggle cancellation.
                      </p>
                      <div className="seat-cancel-legend">
                        <span className="legend-item"><span className="legend-swatch cancel"></span> Selected for cancellation</span>
                        <span className="legend-item"><span className="legend-swatch keep"></span> Kept (click to cancel)</span>
                        <span className="legend-item"><span className="legend-swatch other"></span> Other passengers</span>
                      </div>
                      <div className="cancel-seat-map-scroll">
                        <div className="seat-cancel-layout">
                          <SeatMap
                            busLayout={busLayout}
                            selectedSeats={this.state.cancelSeatNumbers}
                            takenSeats={cancelModeTakenSeats}
                            temporaryTakenSeats={[]}
                            basePrice={0}
                            pricingTiers={[]}
                            maxSeats={userSeats.length}
                            showSeatId={true}
                            onSeatSelect={this.handleCancelSeatToggle}
                          />
                        </div>
                      </div>
                      {cancelUnassignedTotal > 0 && (
                        <div style={{padding: '10px', background: '#f8f8f8', borderRadius: '6px', fontSize: '13px', flexShrink: 0}}>
                          <span style={{fontWeight: 'bold', marginRight: '8px'}}>Unassigned Tickets ({cancelUnassignedTotal})</span>
                          <label style={{margin: '0 6px 0 0'}}>Cancel:</label>
                          <select
                            value={cancelUnassignedCount}
                            onChange={(e) => this.setState({ cancelUnassignedCount: parseInt(e.target.value, 10) })}
                            style={{width: '50px', padding: '3px 4px', borderRadius: '4px', border: '1px solid #ccc'}}
                          >
                            {Array.from({ length: cancelUnassignedTotal + 1 }, (_, i) => i).map((n) => (
                              <option key={n} value={n}>{n}</option>
                            ))}
                          </select>
                        </div>
                      )}
                      <div className="cancel-modal-actions">
                        <Button bsStyle="default" type="button" onClick={() => this.setState({ showCancelSeatGrid: false, cancelUnassignedCount: 0 })}>
                          Back
                        </Button>
                        <Button bsStyle="danger" disabled={this.state.loading || cancelTotalSelected === 0} fill type="button" onClick={this.proceedToCancel.bind(this)}>
                          {this.state.loading ? 'Cancelling…' : (cancelTotalSelected === cancelTotalSeats ? 'Cancel Entire Reservation' : 'Confirm Cancellation')}
                        </Button>
                      </div>
                      {this.state.selectedLeg && this.state.selectedLeg.otherLeg && <div className="other-leg-box">
                        <div>The other leg of this reservation is the following:</div>
                        <div>Reservation #: {config.formatReservationNumber(this.state.selectedLeg.otherLeg.reservationNumber)}</div>
                        <div>Date: {moment(this.state.selectedLeg.otherLeg.slot, 'YYYY-MM-DD').format('dddd MMMM DD YYYY')}</div>
                        <div>From: {(this.state.selectedLeg.otherLeg.depart_stop && this.state.selectedLeg.otherLeg.depart_stop.stop && this.state.selectedLeg.otherLeg.depart_stop.stop.address) || 'N/A'} at {this.state.selectedLeg.depart_stop && this.state.selectedLeg.depart_stop.time ? moment(this.state.selectedLeg.depart_stop.time, 'HH:mm:ss').format('hh:mm:ss A') : ''}</div>
                        <a href="javascript:void(0)" onClick={this.switchCancelLeg.bind(this, this.state.selectedLeg.otherLeg, this.state.selectedLeg)}>Click here to pull up this other reservation for editing</a>
                      </div>}
                    </div>
                  );
                }

                const legacySingleSeat = this.state.selectedLeg && this.state.selectedLeg.total === 1;
                return (
                  <div className="cancel-step">
                    <h4 className="cancel-modal-title">Cancel reservation</h4>
                    {!legacySingleSeat && <Fragment>
                      <p className="cancel-modal-subtitle">How many seats would you like to cancel?</p>
                      <div className="cancel-count-field">
                        <FormInputs
                          ncols={["col-md-12"]}
                          proprieties={[
                            {
                              componentClass: "select",
                              bsClass: "form-control",
                              value: this.state.seatsToCancel,
                              name: 'seatsToCancel',
                              onChange: this.handleSeatsChange.bind(this),
                              options: this.getSeatsOptions()
                            }
                          ]}
                        />
                      </div>
                    </Fragment>}
                    {legacySingleSeat && <p className="cancel-modal-subtitle">This reservation has 1 seat.</p>}
                    {this.state.selectedLeg && this.state.selectedLeg.otherLeg && <div className="other-leg-box">
                      <div>The other leg of this reservation is the following:</div>
                      <div>Reservation #: {config.formatReservationNumber(this.state.selectedLeg.otherLeg.reservationNumber)}</div>
                      <div>Date: {moment(this.state.selectedLeg.otherLeg.slot, 'YYYY-MM-DD').format('dddd MMMM DD YYYY')}</div>
                      <div>From: {(this.state.selectedLeg.otherLeg.depart_stop && this.state.selectedLeg.otherLeg.depart_stop.stop && this.state.selectedLeg.otherLeg.depart_stop.stop.address) || 'N/A'} at {this.state.selectedLeg.depart_stop && this.state.selectedLeg.depart_stop.time ? moment(this.state.selectedLeg.depart_stop.time, 'HH:mm:ss').format('hh:mm:ss A') : ''}</div>
                      <a href="javascript:void(0)" onClick={this.switchCancelLeg.bind(this, this.state.selectedLeg.otherLeg, this.state.selectedLeg)}>Click here to pull up this other reservation for editing</a>
                    </div>}
                    <div className="cancel-modal-actions">
                      <Button bsStyle="default" type="button" onClick={this.closeCancel.bind(this)}>
                        Close
                      </Button>
                      {!legacySingleSeat && <Button bsStyle="danger" disabled={this.state.loading || !this.state.seatsToCancel} fill type="button" onClick={this.proceedToCancel.bind(this)}>
                        {this.state.loading ? 'Cancelling…' : (parseInt(this.state.seatsToCancel, 10) === (this.state.selectedLeg && this.state.selectedLeg.total) ? 'Cancel Entire Reservation' : 'Confirm Cancellation')}
                      </Button>}
                      {(!this.state.seatsToCancel || parseInt(this.state.seatsToCancel, 10) !== (this.state.selectedLeg && this.state.selectedLeg.total)) && <Button bsStyle="danger" disabled={this.state.loading} fill type="button" onClick={() => {
                        confirmAlert({
                          title: 'Cancel Entire Reservation',
                          message: 'Are you sure you want to cancel all seats in this reservation?',
                          buttons: [
                            { label: 'Yes, Cancel All', onClick: () => this.cancelEntireReservation() },
                            { label: 'No', onClick: () => '' }
                          ]
                        });
                      }}>
                        {this.state.loading ? 'Cancelling…' : 'Cancel Entire Reservation'}
                      </Button>}
                    </div>
                  </div>
                );
              })()}
              {this.state.loading && <img alt="" style={{width: '16px', height: '16px', margin: '10px auto', display: 'block'}} src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
              }
            </div>}
          </Modal>
          {/* Manage Seats Modal (Switch / Remove / Assign) */}
          <Modal open={this.state.openManageSeats} onClose={this.closeManageSeatsModal.bind(this)} center classNames={{ modal: 'manage-seats-modal-root' }} showCloseIcon={false}>
            {this.state.openManageSeats && this.state.selectedLeg && <div className="cancelSeatsModal cancel-modal-body">
              {(() => {
                const busLayout = this.state.switchBusLayout;
                const maxSelectableRow = this.state.switchMaxSelectableRow;
                const customerCredits = (this.state.selectedLeg && this.state.selectedLeg.user && this.state.selectedLeg.user.credits) || 0;
                const tiers = this.state.switchPricingTiers || [];
                const userSeats = this.state.selectedLeg ? this.getSeatNumbersForLeg(this.state.selectedLeg) : [];
                const hasAssigned = userSeats.length > 0;
                const hasUnassigned = this.state.selectedLeg ? this.getUnassignedCountForLeg(this.state.selectedLeg) > 0 : false;

                const tabLabel = this.state.manageSeatTab === 'switch' ? 'Switch Seats' : this.state.manageSeatTab === 'remove' ? 'Remove Seats' : 'Assign Seats';

                if (this.state.switchSeatInfoLoading && !busLayout) {
                  return (
                    <div>
                      <div className="manage-seats-header">
                        <h4 className="manage-seats-title">Manage Seats</h4>
                        <button type="button" className="manage-seats-close" onClick={this.closeManageSeatsModal.bind(this)}>&times;</button>
                      </div>
                      <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '400px', padding: '40px 20px'}}>
                        <div style={{width: '40px', height: '40px', border: '3px solid #f3f3f3', borderTop: '3px solid #e8512f', borderRadius: '50%', animation: 'spin 1s linear infinite'}} />
                        <p style={{marginTop: '16px', color: '#888', fontSize: '14px'}}>Fetching seat arrangement...</p>
                      </div>
                    </div>
                  );
                }
                if (!busLayout) {
                  return (
                    <div>
                      <div className="manage-seats-header">
                        <h4 className="manage-seats-title">Manage Seats</h4>
                        <button type="button" className="manage-seats-close" onClick={this.closeManageSeatsModal.bind(this)}>&times;</button>
                      </div>
                      <div className="manage-seats-body"><p>Seat layout not available for this bus.</p></div>
                    </div>
                  );
                }

                if (this.state.manageSeatSuccess) {
                  return (
                    <div>
                      <div className="manage-seats-header">
                        <h4 className="manage-seats-title">Manage Seats</h4>
                        <button type="button" className="manage-seats-close" onClick={this.closeManageSeatsModal.bind(this)}>&times;</button>
                      </div>
                      <div className="manage-seats-body" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '200px', textAlign: 'center'}}>
                        <div style={{width: '48px', height: '48px', borderRadius: '50%', background: '#4CAF50', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px'}}>
                          <span style={{color: '#fff', fontSize: '24px', fontWeight: 700}}>&#10003;</span>
                        </div>
                        <p style={{fontSize: '15px', color: '#1b1e21', fontWeight: 600, margin: '0 0 8px'}}>{this.state.manageSeatSuccess}</p>
                        <Button bsStyle="info" fill type="button" style={{marginTop: '12px'}} onClick={this.closeManageSeatsModal.bind(this)}>Close &amp; Refresh</Button>
                      </div>
                    </div>
                  );
                }

                const tabs = [];
                if (hasAssigned) tabs.push({ key: 'switch', label: 'Switch Seats' });
                if (hasAssigned) tabs.push({ key: 'remove', label: 'Remove Seats' });
                if (hasUnassigned) tabs.push({ key: 'assign', label: 'Assign Seats' });

                return (
                  <div>
                    <div className="manage-seats-header">
                      <h4 className="manage-seats-title">{tabs.length > 1 ? 'Manage Seats' : tabLabel}</h4>
                      <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                        <span className="manage-seats-credit">Credit: ${customerCredits.toFixed(2)}</span>
                        <button type="button" className="manage-seats-close" onClick={this.closeManageSeatsModal.bind(this)}>&times;</button>
                      </div>
                    </div>
                    {tabs.length > 1 && (
                      <div className="manage-seats-tabs">
                        {tabs.map((tab) => (
                          <button key={tab.key} type="button" className={'manage-seats-tab' + (this.state.manageSeatTab === tab.key ? ' active' : '')} onClick={() => this.handleManageSeatTabChange(tab.key)}>
                            {tab.label}
                          </button>
                        ))}
                      </div>
                    )}

                    {/* Switch Seats Tab */}
                    {this.state.manageSeatTab === 'switch' && (() => {
                      if (!userSeats.length) {
                        return <p>No seat assignments found for this reservation.</p>;
                      }

                      const seatsToSwitch = this.state.seatsToSwitch;
                      const mappings = this.state.switchMappings;
                      const isStep2 = this.state.switchStep === 2;

                      const switchActiveRes = this.state.selectedLeg ? this.getActiveReservations(this.state.selectedLeg.reservations) : [];
                      const allMapped = isStep2 && seatsToSwitch.every((s) => mappings[s]);
                      let totalDiff = 0;
                      if (isStep2) {
                        seatsToSwitch.forEach((s) => {
                          if (mappings[s]) {
                            const oldRes = switchActiveRes.find((r) => r.seat_number === s);
                            const oldPrice = getPaidSeatValue(oldRes, s, tiers);
                            totalDiff += getSeatPrice(mappings[s], 0, null, tiers) - oldPrice;
                          }
                        });
                      }

                      const allSeatIds = this.getAllSeatIdsFromLayout(busLayout);
                      const selectableSeatIds = maxSelectableRow != null
                        ? allSeatIds.filter((id) => { const m = id.match(/^(\d+)/); return m && parseInt(m[1], 10) <= maxSelectableRow; })
                        : allSeatIds;
                      const switchUnavailable = (this.state.switchTakenSeats || []).concat(this.state.switchTemporaryTakenSeats || []);
                      const availableSelectableCount = selectableSeatIds.filter((id) => switchUnavailable.indexOf(id) === -1 && userSeats.indexOf(id) === -1).length;
                      const exceedsAvailable = seatsToSwitch.length > 0 && seatsToSwitch.length > availableSelectableCount;

                      let seatMapSection;
                      if (!isStep2) {
                        const otherSeats = allSeatIds.filter((id) => userSeats.indexOf(id) === -1);
                        seatMapSection = (
                          <SeatMap busLayout={busLayout} selectedSeats={seatsToSwitch} takenSeats={otherSeats} temporaryTakenSeats={[]} basePrice={0} pricingTiers={tiers} maxSeats={userSeats.length} maxSelectableRow={maxSelectableRow} showSeatId={true} onSeatSelect={this.handleSwitchSelectToggle} />
                        );
                      } else {
                        const mappedTargets = [];
                        Object.keys(mappings).forEach((k) => { if (mappings[k]) mappedTargets.push(mappings[k]); });
                        const takenForMap = (this.state.switchTakenSeats || []).slice();
                        userSeats.forEach((s) => { if (takenForMap.indexOf(s) === -1) takenForMap.push(s); });
                        const switchTempTaken = (this.state.switchTemporaryTakenSeats || []).filter((s) => mappedTargets.indexOf(s) === -1);
                        seatMapSection = (
                          <SeatMap busLayout={busLayout} selectedSeats={mappedTargets} pendingSeats={this.state.switchPendingSeats} pendingReleaseSeats={this.state.switchPendingReleaseSeats} takenSeats={takenForMap} temporaryTakenSeats={switchTempTaken} basePrice={0} pricingTiers={tiers} maxSeats={seatsToSwitch.length} maxSelectableRow={maxSelectableRow} showSeatId={true} onSeatSelect={this.handleSwitchMapSeat} />
                        );
                      }

                      const mappedCount = seatsToSwitch.filter((s) => mappings[s]).length;
                      const instruction = !isStep2
                        ? 'Select the seat(s) you want to switch, then press Next.'
                        : 'Select ' + seatsToSwitch.length + ' new seat' + (seatsToSwitch.length > 1 ? 's' : '') + '. (' + mappedCount + '/' + seatsToSwitch.length + ' selected)';

                      return (
                        <div className="manage-seats-body">
                          <div className="manage-seats-info" style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                            <span>{instruction}</span>
                            {isStep2 && (
                              <button type="button" style={{background: 'none', border: '1px solid #ccc', borderRadius: '4px', padding: '3px 10px', fontSize: '12px', color: '#666', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0}} onClick={() => {
                                scheduleService.releaseAllHolds(getSessionId()).catch(() => {});
                                const initMappings = {};
                                seatsToSwitch.forEach((s) => { initMappings[s] = null; });
                                this.setState({ switchMappings: initMappings, switchActiveIndex: 0, switchHoldError: null });
                                this.fetchSwitchSeatInfo(this.state.selectedLeg);
                              }}>
                                &#x21bb; Refresh
                              </button>
                            )}
                          </div>

                          {this.state.switchHoldError && (
                            <div style={{background: '#fff3e0', border: '1px solid #ffb74d', borderRadius: '4px', padding: '8px 12px', marginBottom: '8px', fontSize: '13px', color: '#e65100', display: 'flex', alignItems: 'center', gap: '8px'}}>
                              <span style={{fontWeight: 'bold'}}>&#9888;</span>
                              <span>{this.state.switchHoldError}</span>
                            </div>
                          )}

                          <div style={{display: 'flex', flexWrap: 'wrap', gap: '12px'}}>
                            <div className="seat-cancel-layout manage-seats-plain-map" style={{flex: '1 1 280px', maxHeight: '50vh', overflowY: 'auto', padding: '10px 10px 0 10px', position: 'relative'}}>
                              {this.state.switchSeatInfoLoading && (
                                <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(255,255,255,0.8)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: 10, borderRadius: '4px'}}>
                                  <div style={{width: '32px', height: '32px', border: '3px solid #f3f3f3', borderTop: '3px solid #e8512f', borderRadius: '50%', animation: 'spin 1s linear infinite'}} />
                                  <p style={{marginTop: '10px', color: '#888', fontSize: '13px'}}>Refreshing...</p>
                                </div>
                              )}
                              {seatMapSection}
                            </div>
                            <div style={{flex: '0 0 230px', fontSize: '13px'}}>
                              {!isStep2 ? (
                                <div>
                                  <div style={{marginBottom: '14px'}}>
                                    <div style={{fontWeight: 'bold', marginBottom: '6px'}}>Legend</div>
                                    <div style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px'}}>
                                      <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#4CAF50'}} />
                                      <span>Booked seats</span>
                                    </div>
                                    <div style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px'}}>
                                      <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#e8512f'}} />
                                      <span>Selected to switch</span>
                                    </div>
                                    <div style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px'}}>
                                      <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#9E9E9E'}} />
                                      <span>Other / Unavailable</span>
                                    </div>
                                    <div style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: maxSelectableRow != null ? '4px' : '0'}}>
                                      <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#7B1FA2'}} />
                                      <span>Held (temporary)</span>
                                    </div>
                                    {maxSelectableRow != null && (
                                      <div style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
                                        <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#BDBDBD'}} />
                                        <span>First Come First Serve</span>
                                      </div>
                                    )}
                                  </div>
                                  {seatsToSwitch.length > 0 && (
                                    <div style={{background: '#f5f5f5', borderRadius: '6px', padding: '10px'}}>
                                      <div style={{fontWeight: 'bold', marginBottom: '4px'}}>Selected</div>
                                      <p style={{margin: 0}}>{seatsToSwitch.join(', ')}</p>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <div>
                                  <div style={{marginBottom: '14px'}}>
                                    <div style={{fontWeight: 'bold', marginBottom: '6px'}}>Legend</div>
                                    <div style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px'}}>
                                      <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#e8512f'}} />
                                      <span>Selected</span>
                                    </div>
                                    <div style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px'}}>
                                      <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#4CAF50'}} />
                                      <span>Available</span>
                                    </div>
                                    <div style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px'}}>
                                      <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#9E9E9E'}} />
                                      <span>Taken</span>
                                    </div>
                                    <div style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: maxSelectableRow != null ? '4px' : '0'}}>
                                      <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#7B1FA2'}} />
                                      <span>Held (temporary)</span>
                                    </div>
                                    {maxSelectableRow != null && (
                                      <div style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
                                        <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#BDBDBD'}} />
                                        <span>First Come First Serve</span>
                                      </div>
                                    )}
                                  </div>
                                  <div style={{background: '#f5f5f5', borderRadius: '6px', padding: '10px'}}>
                                    <div style={{fontWeight: 'bold', marginBottom: '8px'}}>Switch Mappings</div>
                                    {seatsToSwitch.map((s) => {
                                      const target = mappings[s];
                                      const origRes = switchActiveRes.find((r) => r.seat_number === s);
                                      const origPrice = getPaidSeatValue(origRes, s, tiers);
                                      const newPrice = target ? getSeatPrice(target, 0, null, tiers) : 0;
                                      const d = target ? newPrice - origPrice : 0;
                                      return (
                                        <div key={s} style={{
                                          padding: '8px 10px', marginBottom: '6px', borderRadius: '4px',
                                          background: '#fff', border: '1px solid #e0e0e0',
                                          cursor: target ? 'pointer' : 'default',
                                        }} onClick={() => {
                                          if (!target) return;
                                          const leg = this.state.selectedLeg;
                                          const sbId = typeof leg.schedule_bus === 'object' ? leg.schedule_bus.id : leg.schedule_bus;
                                          scheduleService.releaseSeat(sbId, leg.slot, target, getSessionId()).catch(() => {});
                                          this.setState((prevState) => {
                                            const newMappings = Object.assign({}, prevState.switchMappings);
                                            newMappings[s] = null;
                                            return { switchMappings: newMappings };
                                          });
                                        }}>
                                          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                            <span>
                                              <strong>{s}</strong>{' '}
                                              <span style={{fontSize: '12px'}}>paid ${origPrice.toFixed(2)}</span>
                                              <span style={{margin: '0 6px'}}>&rarr;</span>
                                              {target ? <Fragment><strong>{target}</strong>{' '}<span style={{fontSize: '12px'}}>${newPrice.toFixed(2)}</span></Fragment> : <span style={{color: '#e8512f', fontWeight: 600}}>?</span>}
                                            </span>
                                            {target && d !== 0 && (
                                              <span style={{fontWeight: 600, fontSize: '12px', color: d > 0 ? '#e8512f' : '#4CAF50'}}>
                                                {d > 0 ? '+' : '-'}${Math.abs(d).toFixed(2)}
                                              </span>
                                            )}
                                            {target && d === 0 && (
                                              <span style={{fontWeight: 600, fontSize: '12px', color: '#1b1e21'}}>$0</span>
                                            )}
                                          </div>
                                        </div>
                                      );
                                    })}
                                    {allMapped && (
                                      <div style={{borderTop: '1px solid #ddd', marginTop: '4px', paddingTop: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                        {totalDiff > 0 && <Fragment><strong>Total due</strong><span style={{fontWeight: 700, color: '#e8512f'}}>${totalDiff.toFixed(2)}</span></Fragment>}
                                        {totalDiff < 0 && <Fragment><strong>Credit back</strong><span style={{fontWeight: 700, color: '#4CAF50'}}>${Math.abs(totalDiff).toFixed(2)}</span></Fragment>}
                                        {totalDiff === 0 && <strong>No additional charge</strong>}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                          {allMapped && totalDiff > 0 && (() => {
                            const switchCreditsApplied = this.state.applyCredits ? Math.min(customerCredits, totalDiff) : 0;
                            const switchRemaining = Math.max(totalDiff - switchCreditsApplied, 0);
                            return (
                              <div style={{margin: '10px 0', padding: '10px', background: '#f5f5f5', borderRadius: '4px', fontSize: '13px'}}>
                                {customerCredits > 0 && (
                                  <label style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px', cursor: 'pointer'}}>
                                    <input type="checkbox" checked={!!this.state.applyCredits} onChange={(e) => this.setState({applyCredits: e.target.checked})} />
                                    Apply ${Math.min(customerCredits, totalDiff).toFixed(2)} credits (available: ${customerCredits.toFixed(2)})
                                    {switchCreditsApplied > 0 && switchRemaining > 0 && <span style={{color: '#4CAF50'}}>(remaining: ${switchRemaining.toFixed(2)})</span>}
                                    {switchCreditsApplied > 0 && switchRemaining === 0 && <span style={{color: '#4CAF50'}}>(fully covered)</span>}
                                  </label>
                                )}
                                {switchRemaining > 0 && (
                                  <div>
                                    <label>Payment Method:</label>
                                    <select className="form-control" value={this.state.switchPaymentMethod} onChange={(e) => this.setState({switchPaymentMethod: e.target.value})}>
                                      {this.state.methods.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
                                    </select>
                                    {this.state.switchPaymentMethod === 'card' && (
                                      <div style={{marginTop: '8px'}}>
                                        <input className="form-control" placeholder="Card Holder" value={this.state.cardHolder} onChange={(e) => this.setState({cardHolder: e.target.value, switchCardErrors: Object.assign({}, this.state.switchCardErrors, {cardHolder: undefined})})} style={{marginBottom: '2px'}} />
                                        {this.state.switchCardErrors.cardHolder && <div className="error" style={{fontSize: '12px', color: '#e8512f', marginBottom: '4px'}}>{this.state.switchCardErrors.cardHolder}</div>}
                                        <InputMask maskChar='' mask="9999-9999-9999-9999" className="form-control" placeholder="Card Number" value={this.state.number} onChange={(e) => this.setState({number: e.target.value, switchCardErrors: Object.assign({}, this.state.switchCardErrors, {number: undefined})})} style={{marginBottom: '2px'}} />
                                        {this.state.switchCardErrors.number && <div className="error" style={{fontSize: '12px', color: '#e8512f', marginBottom: '4px'}}>{this.state.switchCardErrors.number}</div>}
                                        <div style={{display: 'flex', gap: '4px'}}>
                                          <div style={{flex: 1}}>
                                            <select className="form-control" value={this.state.month} onChange={(e) => this.setState({month: e.target.value, switchCardErrors: Object.assign({}, this.state.switchCardErrors, {month: undefined})})}>
                                              <option value="">Month</option>
                                              {this.state.months.map((m) => <option key={m} value={m}>{m}</option>)}
                                            </select>
                                            {this.state.switchCardErrors.month && <div className="error" style={{fontSize: '12px', color: '#e8512f'}}>{this.state.switchCardErrors.month}</div>}
                                          </div>
                                          <div style={{flex: 1}}>
                                            <select className="form-control" value={this.state.year} onChange={(e) => this.setState({year: e.target.value, switchCardErrors: Object.assign({}, this.state.switchCardErrors, {year: undefined})})}>
                                              <option value="">Year</option>
                                              {this.state.years.map((y) => <option key={y} value={y}>{y}</option>)}
                                            </select>
                                            {this.state.switchCardErrors.year && <div className="error" style={{fontSize: '12px', color: '#e8512f'}}>{this.state.switchCardErrors.year}</div>}
                                          </div>
                                          <div style={{flex: 1}}>
                                            <InputMask maskChar='' mask="9999" className="form-control" placeholder="CVV" value={this.state.cvv} onChange={(e) => this.setState({cvv: e.target.value, switchCardErrors: Object.assign({}, this.state.switchCardErrors, {cvv: undefined})})} />
                                            {this.state.switchCardErrors.cvv && <div className="error" style={{fontSize: '12px', color: '#e8512f'}}>{this.state.switchCardErrors.cvv}</div>}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            );
                          })()}

                          {!isStep2 && exceedsAvailable && (
                            <div style={{background: '#fff3e0', border: '1px solid #ffb74d', borderRadius: '4px', padding: '8px 12px', marginBottom: '8px', fontSize: '13px', color: '#e65100', display: 'flex', alignItems: 'center', gap: '8px'}}>
                              <span style={{fontWeight: 'bold'}}>&#9888;</span>
                              <span>Only {availableSelectableCount} selectable seat{availableSelectableCount !== 1 ? 's' : ''} available. Please select fewer seats to switch, or cancel and rebook.</span>
                            </div>
                          )}
                          {this.state.switchHoldError && (
                            <div style={{background: '#fff3e0', border: '1px solid #ffb74d', borderRadius: '4px', padding: '10px 12px', margin: '10px 0 0', fontSize: '13px', color: '#e65100', display: 'flex', alignItems: 'center', gap: '8px'}}>
                              <span style={{fontWeight: 'bold'}}>&#9888;</span>
                              <span>{this.state.switchHoldError}</span>
                            </div>
                          )}
                          <div className="cancel-modal-actions">
                            {isStep2 && (
                              <Button bsStyle="default" type="button" onClick={() => { scheduleService.releaseAllHolds(getSessionId()).catch(() => {}); this.setState({ switchStep: 1, switchMappings: {} }); }}>Back</Button>
                            )}
                            {!isStep2 && seatsToSwitch.length > 0 && (
                              <Button bsStyle="info" disabled={exceedsAvailable} fill type="button" onClick={() => {
                                const initMappings = {};
                                seatsToSwitch.forEach((s) => { initMappings[s] = null; });
                                this.setState({ switchStep: 2, switchMappings: initMappings, switchActiveIndex: 0 });
                              }}>Next</Button>
                            )}
                            {isStep2 && allMapped && (
                              <Button bsStyle="info" disabled={this.state.switchLoading} fill type="button" onClick={this.proceedSwitchSeat.bind(this)}>
                                {this.state.switchLoading ? 'Processing…' : 'Confirm Switch'}
                              </Button>
                            )}
                          </div>
                        </div>
                      );
                    })()}

                    {/* Remove Seats Tab */}
                    {this.state.manageSeatTab === 'remove' && (() => {
                      if (!userSeats.length) {
                        return <p>No seat assignments found for this reservation.</p>;
                      }
                      const allSeatIds = this.getAllSeatIdsFromLayout(busLayout);
                      const otherPassengerSeats = allSeatIds.filter((id) => userSeats.indexOf(id) === -1);
                      const cancelSeats = this.state.cancelAddonSeats;
                      const activeRes = this.state.selectedLeg ? this.getActiveReservations(this.state.selectedLeg.reservations) : [];
                      const refundTotal = cancelSeats.reduce((sum, s) => {
                        const res = activeRes.find((r) => r.seat_number === s);
                        return sum + (getPaidSeatValue(res, s, tiers));
                      }, 0);
                      return (
                        <div className="manage-seats-body">
                          <p className="manage-seats-info">
                            Select seat(s) to remove the assignment. The reservation will remain active (converted to general seating).
                          </p>

                          <div style={{display: 'flex', flexWrap: 'wrap', gap: '12px'}}>
                            <div className="seat-cancel-layout manage-seats-plain-map" style={{flex: '1 1 280px', maxHeight: '50vh', overflowY: 'auto', padding: '10px 10px 0 10px', position: 'relative'}}>
                              {this.state.switchSeatInfoLoading && (
                                <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(255,255,255,0.8)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: 10, borderRadius: '4px'}}>
                                  <div style={{width: '32px', height: '32px', border: '3px solid #f3f3f3', borderTop: '3px solid #e8512f', borderRadius: '50%', animation: 'spin 1s linear infinite'}} />
                                  <p style={{marginTop: '10px', color: '#888', fontSize: '13px'}}>Refreshing...</p>
                                </div>
                              )}
                              <SeatMap
                                busLayout={busLayout}
                                selectedSeats={cancelSeats}
                                takenSeats={otherPassengerSeats}
                                temporaryTakenSeats={[]}
                                basePrice={0}
                                pricingTiers={tiers}
                                maxSeats={userSeats.length}
                                maxSelectableRow={maxSelectableRow}
                                showSeatId={true}
                                onSeatSelect={this.handleCancelAddonSeatToggle}
                              />
                            </div>
                            <div style={{flex: '0 0 230px', fontSize: '13px'}}>
                              <div style={{marginBottom: '14px'}}>
                                <div style={{fontWeight: 'bold', marginBottom: '6px'}}>Legend</div>
                                <div style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px'}}>
                                  <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#4CAF50'}} />
                                  <span>Customer seats</span>
                                </div>
                                <div style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px'}}>
                                  <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#e8512f'}} />
                                  <span>Selected to remove</span>
                                </div>
                                <div style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px'}}>
                                  <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#9E9E9E'}} />
                                  <span>Other / Unavailable</span>
                                </div>
                                <div style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: maxSelectableRow != null ? '4px' : '0'}}>
                                  <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#7B1FA2'}} />
                                  <span>Held (temporary)</span>
                                </div>
                                {maxSelectableRow != null && (
                                  <div style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
                                    <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#BDBDBD'}} />
                                    <span>First Come First Serve</span>
                                  </div>
                                )}
                              </div>
                              {cancelSeats.length > 0 && (
                                <div style={{background: '#f5f5f5', borderRadius: '6px', padding: '10px'}}>
                                  <div style={{fontWeight: 'bold', marginBottom: '4px'}}>Selected to remove</div>
                                  <p style={{margin: 0}}>{cancelSeats.join(', ')}</p>
                                  {refundTotal > 0 && <p style={{margin: '6px 0 0', color: '#e8512f', fontWeight: '600'}}>Refund: ${refundTotal.toFixed(2)} credit</p>}
                                </div>
                              )}
                            </div>
                          </div>

                          {this.state.switchHoldError && (
                            <div style={{background: '#fff3e0', border: '1px solid #ffb74d', borderRadius: '4px', padding: '10px 12px', margin: '10px 0 0', fontSize: '13px', color: '#e65100', display: 'flex', alignItems: 'center', gap: '8px'}}>
                              <span style={{fontWeight: 'bold'}}>&#9888;</span>
                              <span>{this.state.switchHoldError}</span>
                            </div>
                          )}
                          <div className="cancel-modal-actions">
                            <Button bsStyle="warning" disabled={this.state.cancelAddonLoading || !cancelSeats.length} fill type="button" onClick={this.proceedCancelAddon.bind(this)}>
                              {this.state.cancelAddonLoading ? 'Processing…' : 'Remove Seat Selection'}
                            </Button>
                          </div>
                        </div>
                      );
                    })()}

                    {/* Assign Seats Tab */}
                    {this.state.manageSeatTab === 'assign' && (() => {
                      const assignSelected = this.state.assignSelectedSeats;
                      const maxSeats = this.state.assignMaxSeats;
                      const takenForMap = (this.state.switchTakenSeats || []).filter((s) => assignSelected.indexOf(s) === -1);
                      const tempTaken = (this.state.switchTemporaryTakenSeats || []).filter((s) => assignSelected.indexOf(s) === -1);

                      let assignTotal = 0;
                      assignSelected.forEach((s) => { assignTotal += getSeatPrice(s, 0, null, tiers); });

                      const paymentSection = assignSelected.length > 0 && assignTotal > 0;

                      return (
                        <div className="manage-seats-body">
                          <p className="manage-seats-info">
                            Select {maxSeats} seat{maxSeats > 1 ? 's' : ''} to assign. {assignSelected.length} of {maxSeats} selected.
                          </p>

                          <div style={{display: 'flex', flexWrap: 'wrap', gap: '12px'}}>
                            <div className="seat-cancel-layout manage-seats-plain-map" style={{flex: '1 1 280px', maxHeight: '50vh', overflowY: 'auto', padding: '10px 10px 0 10px', position: 'relative'}}>
                              {this.state.switchSeatInfoLoading && (
                                <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(255,255,255,0.8)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: 10, borderRadius: '4px'}}>
                                  <div style={{width: '32px', height: '32px', border: '3px solid #f3f3f3', borderTop: '3px solid #e8512f', borderRadius: '50%', animation: 'spin 1s linear infinite'}} />
                                  <p style={{marginTop: '10px', color: '#888', fontSize: '13px'}}>Refreshing...</p>
                                </div>
                              )}
                              <SeatMap busLayout={busLayout} selectedSeats={assignSelected} pendingSeats={this.state.assignPendingSeats} pendingReleaseSeats={this.state.assignPendingReleaseSeats} takenSeats={takenForMap} temporaryTakenSeats={tempTaken} basePrice={0} pricingTiers={tiers} maxSeats={maxSeats} maxSelectableRow={maxSelectableRow} showSeatId={true} onSeatSelect={this.handleAssignSeatSelect} />
                            </div>
                            <div style={{flex: '0 0 230px', fontSize: '13px'}}>
                              <div style={{marginBottom: '14px'}}>
                                <div style={{fontWeight: 'bold', marginBottom: '6px'}}>Legend</div>
                                <div style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px'}}>
                                  <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#e8512f'}} />
                                  <span>Selected</span>
                                </div>
                                <div style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px'}}>
                                  <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#4CAF50'}} />
                                  <span>Available</span>
                                </div>
                                <div style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px'}}>
                                  <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#9E9E9E'}} />
                                  <span>Taken</span>
                                </div>
                                <div style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: maxSelectableRow != null ? '4px' : '0'}}>
                                  <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#7B1FA2'}} />
                                  <span>Held (temporary)</span>
                                </div>
                                {maxSelectableRow != null && (
                                  <div style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
                                    <div style={{width: '14px', height: '14px', borderRadius: '3px', backgroundColor: '#BDBDBD'}} />
                                    <span>First Come First Serve</span>
                                  </div>
                                )}
                              </div>
                              {assignSelected.length > 0 && (
                                <div style={{background: '#f5f5f5', borderRadius: '6px', padding: '10px'}}>
                                  <div style={{fontWeight: 'bold', marginBottom: '6px'}}>Selected Seats</div>
                                  {assignSelected.map((s) => {
                                    const price = getSeatPrice(s, 0, null, tiers);
                                    return (
                                      <div key={s} style={{display: 'flex', justifyContent: 'space-between', marginBottom: '4px'}}>
                                        <strong>{s}</strong>
                                        {price > 0 ? <span style={{color: '#e8512f'}}>+${price.toFixed(2)}</span> : <span style={{color: '#888'}}>$0</span>}
                                      </div>
                                    );
                                  })}
                                  {assignSelected.length > 1 && (
                                    <div style={{borderTop: '1px solid #ddd', marginTop: '6px', paddingTop: '6px', display: 'flex', justifyContent: 'space-between'}}>
                                      <strong>Total</strong>
                                      <strong style={{color: assignTotal > 0 ? '#e8512f' : '#888'}}>${assignTotal.toFixed(2)}</strong>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>

                          {paymentSection && (() => {
                            const creditsApplied = this.state.applyCredits ? Math.min(customerCredits, assignTotal) : 0;
                            const remaining = Math.max(assignTotal - creditsApplied, 0);
                            return (
                              <div style={{margin: '10px 0', padding: '10px', background: '#f5f5f5', borderRadius: '4px', fontSize: '13px'}}>
                                {customerCredits > 0 && (
                                  <label style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px', cursor: 'pointer'}}>
                                    <input type="checkbox" checked={!!this.state.applyCredits} onChange={(e) => this.setState({applyCredits: e.target.checked})} />
                                    Apply ${Math.min(customerCredits, assignTotal).toFixed(2)} credits (available: ${customerCredits.toFixed(2)})
                                    {creditsApplied > 0 && remaining > 0 && <span style={{color: '#4CAF50'}}>(remaining: ${remaining.toFixed(2)})</span>}
                                    {creditsApplied > 0 && remaining === 0 && <span style={{color: '#4CAF50'}}>(fully covered)</span>}
                                  </label>
                                )}
                                {remaining > 0 && (
                                  <div>
                                    <label>Payment Method:</label>
                                    <select className="form-control" value={this.state.switchPaymentMethod} onChange={(e) => this.setState({switchPaymentMethod: e.target.value})}>
                                      {this.state.methods.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
                                    </select>
                                    {this.state.switchPaymentMethod === 'card' && (
                                      <div style={{marginTop: '8px'}}>
                                        <input className="form-control" placeholder="Card Holder" value={this.state.cardHolder} onChange={(e) => this.setState({cardHolder: e.target.value, switchCardErrors: Object.assign({}, this.state.switchCardErrors, {cardHolder: undefined})})} style={{marginBottom: '2px'}} />
                                        {this.state.switchCardErrors.cardHolder && <div className="error" style={{fontSize: '12px', color: '#e8512f', marginBottom: '4px'}}>{this.state.switchCardErrors.cardHolder}</div>}
                                        <InputMask maskChar='' mask="9999-9999-9999-9999" className="form-control" placeholder="Card Number" value={this.state.number} onChange={(e) => this.setState({number: e.target.value, switchCardErrors: Object.assign({}, this.state.switchCardErrors, {number: undefined})})} style={{marginBottom: '2px'}} />
                                        {this.state.switchCardErrors.number && <div className="error" style={{fontSize: '12px', color: '#e8512f', marginBottom: '4px'}}>{this.state.switchCardErrors.number}</div>}
                                        <div style={{display: 'flex', gap: '4px'}}>
                                          <div style={{flex: 1}}>
                                            <select className="form-control" value={this.state.month} onChange={(e) => this.setState({month: e.target.value, switchCardErrors: Object.assign({}, this.state.switchCardErrors, {month: undefined})})}>
                                              <option value="">Month</option>
                                              {this.state.months.map((m) => <option key={m} value={m}>{m}</option>)}
                                            </select>
                                            {this.state.switchCardErrors.month && <div className="error" style={{fontSize: '12px', color: '#e8512f'}}>{this.state.switchCardErrors.month}</div>}
                                          </div>
                                          <div style={{flex: 1}}>
                                            <select className="form-control" value={this.state.year} onChange={(e) => this.setState({year: e.target.value, switchCardErrors: Object.assign({}, this.state.switchCardErrors, {year: undefined})})}>
                                              <option value="">Year</option>
                                              {this.state.years.map((y) => <option key={y} value={y}>{y}</option>)}
                                            </select>
                                            {this.state.switchCardErrors.year && <div className="error" style={{fontSize: '12px', color: '#e8512f'}}>{this.state.switchCardErrors.year}</div>}
                                          </div>
                                          <div style={{flex: 1}}>
                                            <InputMask maskChar='' mask="9999" className="form-control" placeholder="CVV" value={this.state.cvv} onChange={(e) => this.setState({cvv: e.target.value, switchCardErrors: Object.assign({}, this.state.switchCardErrors, {cvv: undefined})})} />
                                            {this.state.switchCardErrors.cvv && <div className="error" style={{fontSize: '12px', color: '#e8512f'}}>{this.state.switchCardErrors.cvv}</div>}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            );
                          })()}

                          {/* Error sits with the button the admin just pressed — at the top of a
                              scrolling modal it was off-screen and read as 'nothing happened' */}
                          {this.state.switchHoldError && (
                            <div style={{background: '#fff3e0', border: '1px solid #ffb74d', borderRadius: '4px', padding: '10px 12px', margin: '10px 0 0', fontSize: '13px', color: '#e65100', display: 'flex', alignItems: 'center', gap: '8px'}}>
                              <span style={{fontWeight: 'bold'}}>&#9888;</span>
                              <span>{this.state.switchHoldError}</span>
                            </div>
                          )}

                          <div className="cancel-modal-actions">
                            {assignSelected.length > 0 && (
                              <Button bsStyle="info" disabled={this.state.switchLoading || this.state.assignPendingSeats.length > 0 || this.state.assignPendingReleaseSeats.length > 0} fill type="button" onClick={this.proceedAssignSeat.bind(this)}>
                                {this.state.switchLoading ? 'Processing…' : 'Assign ' + assignSelected.length + ' Seat' + (assignSelected.length > 1 ? 's' : '')}
                              </Button>
                            )}
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                );
              })()}
            </div>}
          </Modal>

          <Modal open={this.state.openReschedule} onClose={this.closeReschedule.bind(this)} center>
            {this.state.openReschedule && this.state.selectedLeg && <div className="cancelSeatsModal">
              <FormInputs
                ncols={["col-md-12"]}
                proprieties={[
                  {
                    label: "How many seats you would like to reschedule?",
                    componentClass: "select",
                    bsClass: "form-control",
                    placeholder: "How many seats you would like to reschedule?",
                    value: this.state.seatsToReschedule,
                    name: 'seatsToReschedule',
                    onChange: this.handleSeatsChange.bind(this),
                    options: this.getSeatsOptions()
                  }
                ]}
              />
              {this.state.selectedLeg && this.state.selectedLeg.otherLeg && <div className="other-leg-box">
                <div>The other leg of this reservation is the following:</div>
                <div>Reservation #: {config.formatReservationNumber(this.state.selectedLeg.otherLeg.reservationNumber)}</div>
                <div>Date: {moment(this.state.selectedLeg.otherLeg.slot, 'YYYY-MM-DD').format('dddd MMMM DD YYYY')}</div>
                <div>From: {(this.state.selectedLeg.otherLeg.depart_stop && this.state.selectedLeg.otherLeg.depart_stop.stop && this.state.selectedLeg.otherLeg.depart_stop.stop.address) || 'N/A'} at {this.state.selectedLeg.depart_stop && this.state.selectedLeg.depart_stop.time ? moment(this.state.selectedLeg.depart_stop.time, 'HH:mm:ss').format('hh:mm:ss A') : ''}</div>
                <a href="javascript:void(0)" onClick={this.switchLeg.bind(this, this.state.selectedLeg.otherLeg, this.state.selectedLeg)}>Click here to pull up this other reservation for editing</a>
              </div>}
              {(() => {
                const info = this.getRescheduleSelectionInfo();
                if (!info.count || info.assignedSeats.length === 0) return null;
                return (
                  <div style={{margin: '10px 0'}}>
                    <div style={{fontWeight: 600, marginBottom: 6}}>Which tickets should move?</div>
                    <div style={{fontSize: '0.85em', color: '#666', marginBottom: 6}}>
                      Unassigned tickets are used first. Click a seat to include it in the reschedule instead.
                    </div>
                    <div>
                      {info.assignedSeats.map((seat) => {
                        const on = info.chosen.indexOf(seat) !== -1;
                        return (
                          <span key={seat} onClick={this.toggleRescheduleOldSeat.bind(this, seat)}
                            style={{display: 'inline-block', padding: '4px 12px', margin: '0 6px 6px 0', borderRadius: '14px', cursor: 'pointer',
                              border: on ? '2px solid #e8512f' : '1px solid #ccc',
                              background: on ? '#fdeae5' : '#fff', fontWeight: on ? 600 : 400}}>
                            {seat}
                          </span>
                        );
                      })}
                    </div>
                    <div style={{fontSize: '0.9em', marginTop: 4}}>
                      Moving: <strong>{info.chosen.length}</strong> seat{info.chosen.length !== 1 ? 's' : ''}{info.chosen.length > 0 ? ' (' + info.chosen.join(', ') + ')' : ''} + <strong>{Math.max(0, info.unassignedUsed)}</strong> unassigned ticket{Math.max(0, info.unassignedUsed) !== 1 ? 's' : ''}
                    </div>
                    {!info.valid && <div style={{color: '#c0392b', fontSize: '0.85em', marginTop: 4}}>
                      {info.chosen.length > info.count
                        ? 'You selected more seats than the number of tickets to reschedule.'
                        : 'Only ' + info.seatlessCount + ' unassigned ticket' + (info.seatlessCount !== 1 ? 's' : '') + ' available — select at least ' + info.forcedMin + ' seat' + (info.forcedMin !== 1 ? 's' : '') + '.'}
                    </div>}
                  </div>
                );
              })()}
              <Button bsStyle="info" disabled={this.state.loading || !this.state.seatsToReschedule || !this.getRescheduleSelectionInfo().valid} fill type="button" onClick={this.proceedToReschedule.bind(this)}>
                Proceed
              </Button>
              {this.state.loading && <img alt="" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
              }
            </div>}
          </Modal>
          <Modal open={this.state.openBook} onClose={this.closeBook.bind(this)} center>
            {this.state.openBook && <div className="cancelSeatsModal bookingModal">
              {this.state.selectedStop && this.state.selectedLeg && <h4 className="edit-existing-title">You are rescheduling {this.state.seatsToReschedule} seat{parseInt(this.state.seatsToReschedule, 10) !== 1 ? 's' : ''} of the existing reservation for {this.state.selectedLeg.user.firstName + ' ' + this.state.selectedLeg.user.lastName}, leaving from {this.state.selectedStop.address} at {moment(this.state.selectedStop.time, 'HH:mm:ss').format('hh:mm a')} on {this.state.selectedLeg.slot}</h4>}
              <form name="mainForm" onSubmit={this.findSeats.bind(this)}>
                <Row className="form-group">
                  <Col md={3}>
                    <label>Choose Date</label>
                  </Col>
                  <Col md={9}>
                    <DatePicker
                      className="form-control"
                      selected={this.state.departDate}
                      onChangeRaw={this.handleDateChangeRaw.bind(this)}
                      onChange={this.handleDepartDate.bind(this)}
                    />
                  </Col>
                </Row>
                <Row className="form-group">
                  <Col md={3}>
                    <label>Leaving From</label>
                  </Col>
                  <Col md={9}>
                    <select
                      className = "form-control"
                      value = {this.state.departCity}
                      name = "departCity"
                      onChange = {this.handleChange.bind(this)}
                    >
                      <option value=""></option>
                      {
                        (this.props.stops || []).map((stop, key) => {
                          return(<option key={key} value={stop.city}>{stop.label}</option>)
                        })
                      }
                    </select>
                  </Col>
                </Row>

                <Row className="form-group">
                  <Col md={3}>
                    <label>Arriving To</label>
                  </Col>
                  <Col md={9}>
                    <select
                      className = "form-control"
                      value = {this.state.arriveCity}
                      name = "arriveCity"
                      onChange = {this.handleChange.bind(this)}
                    >
                      <option value=""></option>
                      {
                            this.state.arriveCities.map((stop, key) => {
                              return(<option key={key} value={stop.city}>{stop.label}</option>)
                            })
                      }
                    </select>
                  </Col>
                </Row>
                <Button disabled={this.state.loading || !this.state.departDate || !this.state.departCity || !this.state.arriveCity} bsStyle="info" fill type="submit">
                  Go
                </Button>
                {this.state.loading && 
                  <img alt="" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                }
                {this.state.error && <div className="error">{this.state.error}</div>}
                {this.state.noSchedule && <div className="error text-center">No schedules found for this date and destination</div>}
                <div className="clearfix" />
              </form>
            </div>}
          </Modal>
          <Modal open={this.state.openSchedule} onClose={this.closeSchedule.bind(this)} center>
            {this.state.openSchedule && this.state.selectedLeg && <div className="cancelSeatsModal bookingModal">
              {this.state.selectedStop && this.state.selectedLeg && <h4 className="edit-existing-title">You are rescheduling {this.state.seatsToReschedule} seat{parseInt(this.state.seatsToReschedule, 10) !== 1 ? 's' : ''} of the existing reservation for {this.state.selectedLeg.user.firstName + ' ' + this.state.selectedLeg.user.lastName}, leaving from {this.state.selectedStop.address} at {moment(this.state.selectedStop.time, 'HH:mm:ss').format('hh:mm a')} on {this.state.selectedLeg.slot}</h4>}
                <Row className="main-box-container">
                  <Col md={12}>
                    <div className="main-schedule-box">
                      <div className="border-black head">
                      {this.state.schedules && this.state.schedules[0] && this.state.schedules[0].isSpecial && !this.state.schedules[0].specialPrice &&
                        <div className="special-main-schedule">--Date has special schedule--</div>
                      }
                      {this.state.schedules && this.state.schedules[0] && this.state.schedules[0].isSpecial && this.state.schedules[0].specialPrice &&
                        <div className="special-main-schedule">--Date has special schedule and price--</div>
                      }
                      Leaving from {this.getCityLabel(this.state.departCity)} on <br/> {moment(this.state.departDate).format('dddd, MMMM Do YYYY')}
                      </div>
                      {this.state.schedules && this.state.schedules.map((bus, index) => {
                        return (
                          <div key={index} className={'bus-box-main ' + (bus.deleted ? 'deleted' : '')}>
                            <div className="border-black bus-number">Bus #{index+1}:</div>
                            <div className="stops-group">
                              {bus.stops.map((stop, i) => {
                                return (
                                  stop.type === 'PU' &&
                                  <div key={i} className={'border-black stop-times '+ (stop.deleted ? 'deleted' : '')}>
                                    <span className="stop-address">
                                      {moment(stop.time, 'HH:mm:ss').format('hh:mm a')} from {stop.stop.address}
                                    </span>
                                      <input checked={this.state.departStop === stop.id} className="res-slot" type="radio" name="departStop" value={this.state.departStop} onChange={this.selectDepartStop.bind(this, stop, index)} />
                                  </div>
                                )
                              })}
                            </div>
                            <div className="border-black">
                              <div className="total-row">Total: {bus.reservations} {bus.bus_type.type === 'Elite' ? (<span className="elite-res">Elite</span>) : ''}{bus.bus_type.type === 'Elite' ? ' ' : ''} Max Capacity: {bus.capacity}</div>
                              <div className="main-driver">Driver: {bus.bus_type.driver ? bus.bus_type.driver.firstName + ' ' + bus.bus_type.driver.lastName : ''}</div>
                              <div className="main-driver">Company: {bus.bus_type.company}</div>
                              <div className="main-price-label">Coupons Allowed:</div>
                              <div className="main-price-value">{bus.couponLimit}</div>
                              {bus.prices ?<div className="main-price-value">Price:  <button onClick={()=>{this.showEditPrice(bus, index)}}>View Price</button> </div> :
                              <span className={(bus.bus_type.defaultPrice !== bus.price ? "red-text-price" : "")}><b>Price:</b>&nbsp;
                                      {bus.bus_type.defaultPrice === bus.price && <Fragment>${bus.price} (unchanged)</Fragment>}
                                      {/* {bus.bus_type.defaultPrice !== bus.price && bus.firstSeats ? <Fragment>${bus.price} (price for first {bus.firstSeats} seats)</Fragment> : ''} */}
                                      {/* {bus.bus_type.defaultPrice !== bus.price && bus.lastSeats ? <Fragment>${bus.price} (price for last {bus.lastSeats} seats)</Fragment> : ''} */}
                                      {bus.prices && bus.bus_type.defaultPrice !== bus.price ? <Fragment>${bus.price} (custom price for this route)</Fragment> : bus.bus_type.defaultPrice !== bus.price && !bus.firstSeats && !bus.lastSeats ? <Fragment>${bus.price} (special price for whole bus)</Fragment> : ''}
                                </span>}
                              <div className="main-price-label">Bus is:</div>
                              <div className="main-price-value">{bus.isOpen ? 'Open' : 'Closed'}</div>
                              {bus.notes && <div className="main-price-label">Bus Notes:</div>}
                              {bus.notes && <div className="main-price-value">{bus.notes}</div>}
                              <div>Destinations: 
                                <div className="stops-group">
                                  {bus.stops.map((stop, i) => {
                                    return (
                                      stop.type === 'DO' &&
                                      <div key={i} className={'border-black stop-times '+ (stop.deleted ? 'deleted' : '')}>
                                        <span>{moment(stop.time, 'HH:mm:ss').format('hh:mm a')} at {stop.stop.address}</span>
                                        {(this.state.arriveStop === stop.id) && <i className='fa fa-check'></i>}
                                        <div className="view-res-link">{stop.reservations}</div>
                                      </div>
                                    )
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      })}  
                    </div>
                  </Col>
                </Row>
                {this.state.selectedBus !== null && this.state.skipSeatSelection && this.state.selectedLeg && !this.getActiveReservations(this.state.selectedLeg.reservations)[0].vouchers && (
                  <Row style={{margin: '10px 0'}}>
                    <Col md={12}>
                      <Button bsStyle="info" fill type="button" onClick={this.openSeatSelection.bind(this)}>
                        Assign Seat
                      </Button>
                      <span style={{ marginLeft: '12px', color: '#6b7280', fontSize: '13px' }}>
                        No seats selected for new reservation. Click "Assign Seat" to pick seats, or proceed below.
                      </span>
                    </Col>
                  </Row>
                )}
                {this.state.selectedBus !== null && this.state.selectedLeg && !!this.getActiveReservations(this.state.selectedLeg.reservations)[0].vouchers && (
                  <Row style={{margin: '10px 0'}}>
                    <Col md={12}>
                      {(() => {
                        const bannerBreakup = this.getPricePaidBreakup();
                        const bannerSeatCash = (bannerBreakup.object.paid || 0) + (bannerBreakup.object.credits || 0);
                        return (
                          <div style={{ padding: '10px 12px', background: '#fff3e0', border: '1px solid #ffb74d', borderRadius: '6px', color: '#e65100', fontSize: '13px', fontWeight: 'bold' }}>
                            &#9888; Seat selection isn't available when rescheduling a points-paid ticket. Assign a seat afterward via "Manage Seats".
                            {bannerSeatCash > 0 ? ' The ' + numeral(bannerSeatCash).format('$0,0.00') + ' already paid for the seat add-on will be refunded to the customer\'s account credit.' : ''}
                          </div>
                        );
                      })()}
                    </Col>
                  </Row>
                )}
                {this.state.selectedBus !== null && !this.state.skipSeatSelection && !this.state.showRescheduleSeatSelection && this.state.rescheduleSelectedSeats.length > 0 && (
                  <Row style={{margin: '10px 0'}}>
                    <Col md={12}>
                      <span style={{ color: '#333', fontSize: '14px', marginRight: '12px' }}>
                        Seats selected: <strong>{this.state.rescheduleSelectedSeats.join(', ')}</strong>
                      </span>
                      <Button bsStyle="default" type="button" onClick={this.editSeatSelection.bind(this)}>
                        Edit Seats
                      </Button>
                    </Col>
                  </Row>
                )}
                <Modal
                  open={!!this.state.showRescheduleSeatSelection}
                  onClose={this.closeSeatSelection.bind(this)}
                  center
                  classNames={{ modal: 'reschedule-seat-modal' }}
                >
                  {this.state.showRescheduleSeatSelection && (
                    <Fragment>
                      {this.state.error && <div className="error" style={{marginBottom: 8}}>{this.state.error}</div>}
                      {this.renderRescheduleSeatSection()}
                      <Row style={{margin: '16px 0 4px'}}>
                        <Col md={12}>
                          <Button bsStyle="info" fill type="button"
                            disabled={this.state.reschedulePendingSeats.length > 0 || this.state.reschedulePendingReleaseSeats.length > 0 || (!this.state.skipSeatSelection && (this.state.rescheduleSelectedSeats.length !== (parseInt(this.state.seatsToReschedule, 10) || 0)))}
                            onClick={() => this.setState({ showRescheduleSeatSelection: false })}>
                            Confirm
                          </Button>
                          <Button bsStyle="default" type="button" style={{ marginLeft: '10px' }} onClick={this.closeSeatSelection.bind(this)}>
                            Cancel
                          </Button>
                        </Col>
                      </Row>
                    </Fragment>
                  )}
                </Modal>
                {(this.state.showRescheduleSeatSelection || this.state.skipSeatSelection || this.state.rescheduleSelectedSeats.length > 0) && <Fragment>
                <FormInputs
                  ncols={["col-md-12"]}
                  proprieties={[
                    {
                      label: "Add note to new reservation",
                      type: "text",
                      bsClass: "form-control",
                      placeholder: "Remark",
                      value: this.state.remark,
                      name: 'remark',
                      onChange: this.handleChange
                    }
                  ]}
                />
                { this.state.selectedLeg && this.state.schedules && this.state.schedules.length && this.state.selectedBus !== null ?
                  (<Fragment>
                    <Row>
                      <Col md={12} className='title'>
                        <h5 className="select-to-pay" style={{fontWeight: 'bold'}}>
                          Rescheduling {this.state.seatsToReschedule} seat{parseInt(this.state.seatsToReschedule, 10) !== 1 ? 's' : ''}
                        </h5>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} className='title'>
                        {(() => {
                          const breakup = this.getPricePaidBreakup();
                          const total = breakup.object.paid + breakup.object.credits;
                          const seatCount = parseInt(this.state.seatsToReschedule, 10) || 0;
                          return (
                            <Fragment>
                              <h5 className="select-to-pay">
                                Customer Paid: {numeral(total).format('$0,0.00')} for {seatCount} seat{seatCount !== 1 ? 's' : ''}
                              </h5>
                              {breakup.object.credits > 0 && <p style={{fontSize: '12px', color: '#888', margin: '2px 0 0 0', textAlign: 'center'}}>(Tripperbus Credits)</p>}
                              {breakup.object.points > 0 && (() => {
                                const bRes = this.getRescheduleMovingReservations();
                                let bPointsBase = 0;
                                let bAllPoints = seatCount > 0;
                                for (let i = 0; i < bRes.length; i++) {
                                  if (bRes[i] && bRes[i].vouchers) {
                                    bPointsBase += (bRes[i].order_item ? bRes[i].order_item.amount : 0);
                                  } else {
                                    bAllPoints = false;
                                  }
                                }
                                const bCash = breakup.object.paid + breakup.object.credits;
                                return (
                                  <p style={{fontSize: '12px', color: '#555', margin: '2px 0 0 0', textAlign: 'center'}}>
                                    {breakup.object.points} Points covered the {numeral(bPointsBase).format('$0,0.00')} base fare
                                    {bAllPoints && bCash > 0 ? ' — the ' + numeral(bCash).format('$0,0.00') + ' above is cash paid for the seat add-on' : ''}
                                  </p>
                                );
                              })()}
                              {breakup.object.credits > 0 && (
                                <p style={{fontSize: '11px', color: '#aaa', margin: '2px 0 0 0', textAlign: 'center', fontStyle: 'italic'}}>
                                  Credits are applied per leg. Amount shown is for this leg only.
                                </p>
                              )}
                              {breakup.object.credits === 0 && breakup.object.points === 0 && this.state.selectedLeg.reservations && this.state.selectedLeg.reservations[0] && this.state.selectedLeg.reservations[0].order_item && this.state.selectedLeg.reservations[0].order_item.order && (
                                <p style={{fontSize: '12px', color: '#888', margin: '2px 0 0 0', textAlign: 'center'}}>
                                  Payment method: {this.state.selectedLeg.reservations[0].order_item.order.paymentMethod}
                                </p>
                              )}
                            </Fragment>
                          );
                        })()}
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} className='title'>
                        <h5 className="select-to-pay">New Seats Price: {numeral(this.getNewEffectiveTotal()).format('$0,0.00')}</h5>
                        {this.state.rescheduleSelectedSeats.length > 0 ? (
                          <div style={{fontSize: '13px', color: '#555', margin: '4px auto 0', maxWidth: '260px', textAlign: 'left'}}>
                            {(() => {
                              const busType = this.getRescheduleBusType();
                              const rscBasePrice = this.state.selectedRoutePrice || 0;
                              const tiers = this.state.reschedulePricingTiers;
                              return this.state.rescheduleSelectedSeats.map((seatId) => {
                                const seatTotal = getSeatPrice(seatId, rscBasePrice, busType, tiers);
                                const addOn = seatTotal - rscBasePrice;
                                return (
                                  <div key={seatId} style={{display: 'flex', justifyContent: 'space-between', padding: '1px 0'}}>
                                    <span>Seat {seatId}</span>
                                    <span>{numeral(rscBasePrice).format('$0,0.00')}{addOn > 0 ? ' + ' + numeral(addOn).format('$0,0.00') + ' add-on' : ''}</span>
                                  </div>
                                );
                              });
                            })()}
                          </div>
                        ) : (
                          <p style={{fontSize: '12px', color: '#888', margin: '2px 0 0 0', textAlign: 'center'}}>
                            {numeral(this.state.selectedRoutePrice).format('$0,0.00')} &times; {this.state.seatsToReschedule} seat{parseInt(this.state.seatsToReschedule, 10) !== 1 ? 's' : ''}
                          </p>
                        )}
                      </Col>
                    </Row>
                  </Fragment>)
                : ''}
                {this.getAmount() !== 0 && <div>
                  {/*<FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        label: "Override Difference Amount",
                        type: "number",
                        bsClass: "form-control",
                        placeholder: "Amount",
                        value: this.state.customAmount,
                        name: 'customAmount',
                        onChange: this.handleChange,
                        min: 0
                      }
                    ]}
                  />*/}
                  {this.state.selectedLeg && !this.getActiveReservations(this.state.selectedLeg.reservations)[0].vouchers && this.state.selectedLeg.user.credits > 0 && <Row>
                    <Col md={12}>
                      <div className="apply-credit-row">Applied Tripperbus Credit to cover the amount {numeral(this.getAmount() > this.state.selectedLeg.user.credits ? this.state.selectedLeg.user.credits : this.getAmount()).format('$0.00')}
                      </div>
                    </Col>
                    <Col md={12}>
                      <div className="apply-credit-row">Customer's Tripperbus Credit Balance will be {numeral(this.state.selectedLeg.user.credits - (this.getAmount() > this.state.selectedLeg.user.credits ? this.state.selectedLeg.user.credits : this.getAmount())).format('$0.00')} after payment
                      </div>
                    </Col>
                  </Row>}
                  {this.state.selectedLeg && this.getActiveReservations(this.state.selectedLeg.reservations)[0].vouchers && this.getRequiredPoints().points > 0 && this.state.selectedLeg.user.points >= this.getRequiredPoints().points ? <Row>
                    <Col md={12}>
                      <div className="apply-credit-row">
                        Transferred {this.getRequiredPoints().points} Voucher Points to cover cost of new reservation
                      </div>
                    </Col>
                  </Row> : ''}
                  {this.getActiveReservations(this.state.selectedLeg.reservations)[0].vouchers && this.state.selectedLeg.user.points < this.getRequiredPoints().points ? <Fragment>
                    <Row>
                      <Col md={12}>
                        <div className="select-to-pay">
                          {this.getVouchersMessage()}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <div className="select-to-pay">
                          Payment must be done with credit card due to insufficient points, points in cancelled reservation will be returned.
                        </div>
                      </Col>
                    </Row>
                  </Fragment> : ''}
                  {/*{((this.getCredits() + this.getRequiredPoints().pointsAmount) < this.getAmount()) && <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        label: "Payment Method",
                        type: "text",
                        componentClass: "select",
                        bsClass: "form-control",
                        placeholder: "Payment Method",
                        value: this.state.paymentMethod,
                        name: 'paymentMethod',
                        options: this.state.methods,
                        onChange: this.handleChange.bind(this)
                      }
                    ]}
                  />}*/}
                  {this.state.paymentMethod === 'card' && ((this.getCredits() + this.getRequiredPoints().pointsAmount) < this.getAmount()) ? <Fragment>
                    <Row>
                      <Col md={12}>
                        <h5 className="select-to-pay">There is a difference of {numeral(this.getAmount() - (this.getCredits() + this.getRequiredPoints().pointsAmount)).format('$0.00')} to be paid with Credit Card.</h5>
                      </Col>
                    </Row>
                  </Fragment> : ''}
                  {this.state.paymentMethod === 'card' && ((this.getCredits() + this.getRequiredPoints().pointsAmount) < this.getAmount()) ?
                    <div>
                      <div className="row clearfix">
                        <div className="col-sm-6 form-group">
                          <label className="formLable">NAME ON CARD (If different from above)</label>
                          <input ref="cardHolder" required name="cardHolder" value={this.state.cardHolder} onChange={this.handleChange.bind(this)} type="text" className="form-control" placeholder="Name On Card" />
                        </div>
                        <div className="col-sm-6 form-group">
                          <label className="formLable">CREDIT CARD NUMBER</label>
                          <InputMask maskChar='' mask="9999-9999-9999-9999" ref="number" onChange={this.handleChange.bind(this)} value={this.state.number} name="number" required className='form-control' placeholder="Credit Card Number" />
                          {this.state.submitted && !this.state.number && <div className="error">Number is required</div>}
                        </div>
                      </div>
                      <div className="row clearfix">
                        <div className="col-sm-4 form-group">
                          <label className="formLable">EXMONTH</label>
                          <select ref="month" required name="month" value={this.state.month} onChange={this.handleChange.bind(this)}   className='form-control'>
                            <option value=''>MM</option>
                            {this.state.months.map((item, index) => {
                              return (
                                <option key={index}>{item}</option>
                              )
                            })}
                          </select>
                          {this.state.submitted && !this.state.month && <div className="error">Month is required</div>}
                        </div>
                        <div className="col-sm-4 form-group">
                          <label className="formLable">EXYEAR</label>
                          <select ref="year" required name="year" value={this.state.year} onChange={this.handleChange.bind(this)}  className='form-control'>
                            <option value=''>YY</option>
                            {this.state.years.map((item, index) => {
                              return (
                                <option key={index}>{item}</option>
                              )
                            })}
                          </select>
                          {this.state.submitted && !this.state.number && <div className="error">Year is required</div>}
                        </div>
                        <div className="col-sm-4 form-group">
                          <label className="formLable">SEC CODE</label>
                          <InputMask required maskChar='' mask="9999" ref="cvv" onChange={this.handleChange.bind(this)} value={this.state.cvv} name="cvv" className='form-control' placeholder="SEC" />
                          {this.state.submitted && !this.state.cvv && <div className="error">Cvv is required</div>}
                        </div>
                      </div>
                    </div>
                  : ''}
                </div>}
                {(this.state.schedules && this.state.schedules.length && this.state.selectedBus !== null && this.getNewEffectiveTotal() < this.getPricePaidTotal() && this.state.selectedLeg && !this.getActiveReservations(this.state.selectedLeg.reservations)[0].vouchers) ? <Row>
                  <Col md={12}>
                    {!this.state.waiveDifference ? <div className="apply-credit-row">
                      There are {numeral(this.getPricePaidTotal() - this.getNewEffectiveTotal()).format('$0.00')} credits left over from cancellation that will bank.
                    </div> : <div className="apply-credit-row">
                      The difference will not be returned.
                    </div>}
                  </Col>
                  <Col md={12} style={{margin: '5px 0'}}>
                    <label>
                      <input type="checkbox" name="waiveDifference" onChange={this.waiveDifference.bind(this)} /> Do not return the credit difference to customer. Void it.
                    </label>
                  </Col>
                </Row> : ''}
                {(this.state.schedules && this.state.schedules.length && this.state.selectedBus !== null && this.getNewEffectiveTotal() === this.getPricePaidTotal()) ? <Row>
                  <Col md={12}>
                    <div className="apply-credit-row">
                      This reservation is an even exchange.
                    </div>
                  </Col>
                </Row> : ''}
                {(this.state.schedules && this.state.schedules.length && this.state.selectedBus !== null && this.getActiveReservations(this.state.selectedLeg.reservations)[0].vouchers && this.state.schedules[this.state.selectedBus].bus_type.type !== 'Elite' && this.state.selectedLeg.schedule_bus.bus_type.type === 'Elite') ? <Row>
                  <Col md={12}>
                    <div className="apply-credit-row">
                      New ticket is a downgrade, applying {6*this.getSeatsWithPoints(this.getActiveReservations(this.state.selectedLeg.reservations))} points from reservation and voiding the rest.
                    </div>
                  </Col>
                </Row> : ''}
                {(this.state.schedules && this.state.schedules.length && this.state.selectedBus !== null && this.state.selectedLeg && this.getActiveReservations(this.state.selectedLeg.reservations)[0].vouchers && this.state.schedules[this.state.selectedBus].bus_type.type === this.state.selectedLeg.schedule_bus.bus_type.type) ? <Row>
                  <Col md={12}>
                    <div className="apply-credit-row">
                      Applying {(this.state.schedules[this.state.selectedBus].bus_type.type === 'Elite' ? 12 : 6) * this.getSeatsWithPoints(this.getActiveReservations(this.state.selectedLeg.reservations))} points from the reservation to the new reservation — no card charge for the fare.
                    </div>
                  </Col>
                </Row> : ''}
                {!this.state.loading && (!this.state.departStop || !this.state.arriveStop) && <Row><Col md={12}>
                  <div style={{color: '#c0392b', fontSize: '0.9em', margin: '6px 0'}}>
                    {!this.state.departStop
                      ? 'Select a departure time (the radio button) on one of the buses above to enable Reschedule.'
                      : 'The selected bus has no drop-off stop matching the destination city — choose a different bus.'}
                  </div>
                </Col></Row>}
                {this.state.loading && <Row><Col md={12}>
                  <div style={{color: '#666', fontSize: '0.9em', margin: '6px 0'}}>
                    Processing… If this does not complete, <a href="javascript:void(0)" onClick={() => this.setState({loading: false, error: 'The previous attempt did not complete — please review and try again.'})}>click here to unlock the button</a> and retry.
                  </div>
                </Col></Row>}
                <Row><Col md={12}><Button disabled={this.state.loading || !this.state.departStop || !this.state.arriveStop} bsStyle="info" fill type="button" onClick={this.handleSubmit.bind(this)}>
                  Reschedule
                </Button></Col></Row>
                {this.state.loading && 
                  <img alt="" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                }
                {(this.state.error || this.props.error) && <div className="error">{this.state.error || this.props.error}</div>}
                <div className="clearfix" />
                </Fragment>}
            </div>}
          </Modal>
          <Modal open={this.state.openSuccess} onClose={this.closeSuccess.bind(this)} center>
            <div className="cancelSeatsModal">
              <h4>Rescheduled successfully with reservation #{this.state.code}.</h4>
              <Button bsStyle="info" fill type="button" onClick={this.closeSuccess.bind(this)}>
                OK
              </Button>
            </div>
          </Modal>
          <Modal open={this.state.openSentSuccess} onClose={this.closeSentSuccess.bind(this)} center>
            <div className="cancelSeatsModal">
              <h4>{this.state.bulkActionInfo || 'Done.'}</h4>
              <Button bsStyle="info" fill type="button" onClick={this.closeSentSuccess.bind(this)}>
                OK
              </Button>
            </div>
          </Modal>
          <Modal open={this.state.openUpdateSuccess} onClose={this.closeUpdateSuccess.bind(this)} center>
            <div className="cancelSeatsModal">
              <h4>Reservation updated successfully.</h4>
              <Button bsStyle="info" fill type="button" onClick={this.closeUpdateSuccess.bind(this)}>
                OK
              </Button>
            </div>
          </Modal>
          <Modal open={this.state.openActionDetails} onClose={this.closeActionDetails.bind(this)} center>
            <div className="action-records-modal">
              <h3>Record Of action On Reservation</h3>
              {this.state.actionRecord && <div className="action-records">
                <div className="action-record">
                  <label>Action Done:</label>
                  <span>{this.state.actionRecord.type}</span>
                </div>
                <div className="action-record">
                  <label>Date & Time Sent:</label>
                  <span>{moment(this.state.actionRecord.created_at).format('MMM DD, YYYY')} @ {moment(this.state.actionRecord.created_at).format('hh:mm A')}</span>
                </div>
                <div className="action-record">
                  <label>Admin Representative:</label>
                  <span>{this.state.actionRecord.admin_user_first + ' ' + this.state.actionRecord.admin_user_last}</span>
                </div>
                {this.state.actionRecord.type !== 'Custom Text Message' && <div className="action-record">
                  <label>Sent To Email Address:</label>
                  <span>{this.state.actionRecord.emailAddress}</span>
                </div>}
                {(this.state.actionRecord.type === 'Custom Text Message' || this.state.actionRecord.type === 'Custom Emailed & Text Message') && <div className="action-record">
                  <label>Sent To Phone Number:</label>
                  <span>{this.state.actionRecord.phone}</span>
                </div>}
                {this.state.actionRecord.type !== 'Custom Text Message' && <div className="action-record">
                  <label>Email Subject:</label>
                  <span>{this.state.actionRecord.subject}</span>
                </div>}
                {(this.state.actionRecord.type === 'Custom Emailed' || this.state.actionRecord.type === 'Custom Emailed & Text Message') && <div className="action-record">
                  <label>Email Body:</label>
                  <span>{this.state.actionRecord.body}</span>
                </div>}
                {(this.state.actionRecord.type === 'Custom Text Message' || this.state.actionRecord.type === 'Custom Emailed & Text Message') && <div className="action-record">
                  <label>Text Message:</label>
                  <span>{this.state.actionRecord.text}</span>
                </div>}
              </div>}
              <Button bsStyle="info" fill type="button" onClick={this.closeActionDetails.bind(this)}>
                Close
              </Button>
            </div>
          </Modal>
          <Modal open={this.state.showModal} onClose={this.closeSuccess.bind(this)} center>
            <div className="cancelSeatsModal">
              {<CustomPrice updatePrice={()=>{}} open={true} combinationOfStops={this.state.currentSelectedBus} close={()=>this.setState({showModal:false})} updateStopPrice={()=>{}} update={false}/>}
            </div>
          </Modal>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  let { mainItems, loading, error } = state.reservations;
  return { mainItems, loading, error, stops: state.stops.items };
}

export default connect(mapStateToProps)(SearchReservations);
